import React, { useState, FormEvent, useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { Suggest, ItemRenderer, ItemPredicate } from '@blueprintjs/select';
import { FormGroup, InputGroup, AnchorButton, Button, Tabs, Tab, Collapse, HTMLSelect, HTMLTable, ControlGroup, NumericInput, TextArea, Position, Toaster, Intent, MenuItem } from "@blueprintjs/core";
import { Radio, RadioGroup, Switch, Alert, Dialog, DialogBody, Checkbox, Tooltip } from "@blueprintjs/core";
import { H2, H3, H4, H5, H6 } from "@blueprintjs/core";
import { Classes, Card, Elevation, Icon } from "@blueprintjs/core";
 
import { IconNames } from "@blueprintjs/icons";

import { AxiosInstance } from 'axios';

import * as utils from "./utils";

import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next';

import svgWait2 from './svg/wait2.gif'


import { AcStatusInfo } from './Types'
import { SystemHeader } from './CommonUI';

import { transpileModule } from 'typescript';
import { stringify } from 'querystring';
import i18next from 'i18next';
import { FastLayer } from 'react-konva';

interface PageInfo {
    n: number
}

var GsbFlag: any;

const RESR_Code = "ACSR*#"
const RESR_Code_noShow = " "
interface AcStatusViewProps {
    gsb: AxiosInstance,
    AcStatus: AcStatusInfo,
    baseUrl?: string,
    token?: string | null,
    onPrevRec?: () => void,
    onNew?: () => void,
    onEdit?: () => void,
    onDelete?: () => void,
    onNextRec?: () => void,
}



function AcStatusView({ gsb, AcStatus = {} as AcStatusInfo, baseUrl = "", token = "", onPrevRec = () => { }, onNew = () => { }, onEdit = () => { }, onDelete = () => { }, onNextRec = () => { } }: AcStatusViewProps) {

    const [isDeletePress, setisDeletePress] = useState(false)
    const [isParametPress, setisParametPress] = useState(false)

    const [isChecked, setIsChecked] = React.useState(false);
    const [IsShowMe1, setIsShowMe1] = useState(!(RESR_Code_noShow.indexOf(AcStatus.d_StatusCode1) == 1))
    const [IsShowMe2, setIsShowMe2] = useState(!(RESR_Code_noShow.indexOf(AcStatus.d_StatusCode2) == 1))
    const [IsShowMe3, setIsShowMe3] = useState(!(RESR_Code_noShow.indexOf(AcStatus.d_StatusCode3) == 1))
    const [IsShowMe4, setIsShowMe4] = useState(false) // useState(!(RESR_Code_noShow.indexOf(AcStatus.d_StatusCode4) == 1))
    const [IsShowMe5, setIsShowMe5] = useState(false)  //useState(!(RESR_Code_noShow.indexOf(AcStatus.d_StatusCode5) == 1))
    const [IsShowMe6, setIsShowMe6] = useState(false)
    const [IsShowMe7, setIsShowMe7] = useState(false)
    const [IsShowMe8, setIsShowMe8] = useState(false)
    const [IsShowMe9, setIsShowMe9] = useState(false)
    const [IsShowMe10, setIsShowMe10] = useState(false)
    const [IsShowMe11, setIsShowMe11] = useState(false)
    const [IsShowMe12, setIsShowMe12] = useState(false)
    const [IsShowMe13, setIsShowMe13] = useState(false)
    const [IsShowMe14, setIsShowMe14] = useState(false)
    const [IsShowMe15, setIsShowMe15] = useState(false)
    const [IsShowMe16, setIsShowMe16] = useState(false)
    const [IsShowMe17, setIsShowMe17] = useState(false)
    const [IsShowMe18, setIsShowMe18] = useState(false)
    const [IsShowMe19, setIsShowMe19] = useState(false)
    const [IsShowMe20, setIsShowMe20] = useState(false)
    //console.log(AcStatus)

    useEffect(() => {
        (async () => {
            try {         
                
                 if ((AcStatus.d_StatusCode4 === " ")) {
                    setIsShowMe4(false)
                }   
                else
                {
                    setIsShowMe4(true)
                }


                if ((AcStatus.d_StatusCode5  === " ")) {
                    setIsShowMe5(false)
                }   
                else
                {
                    setIsShowMe5(true)
                }
               
                if ((AcStatus.d_StatusCode6 === " ")) {
                    setIsShowMe6(false)
                }
                else {
                    setIsShowMe6(true)
                }
                if ((AcStatus.d_StatusCode7 === " ")) {
                    setIsShowMe7(false)
                }
                else {
                    setIsShowMe7(true)
                }
                if ((AcStatus.d_StatusCode8 === " ")) {
                    setIsShowMe8(false)
                }
                else {
                    setIsShowMe8(true)
                }

                if ((AcStatus.d_StatusCode9 === " ")) {
                    setIsShowMe9(false)
                }
                else {
                    setIsShowMe9(true)
                }     
                
                if ((AcStatus.d_StatusCode10 === " ")) {
                    setIsShowMe10(false)
                }
                else {
                    setIsShowMe10(true)
                }    

                if ((AcStatus.d_StatusCode11 === " ")) {
                    setIsShowMe11(false)
                }
                else {
                    setIsShowMe11(true)
                }

                if ((AcStatus.d_StatusCode12 === " ")) {
                    setIsShowMe12(false)
                }
                else {
                    setIsShowMe12(true)
                }

                if ((AcStatus.d_StatusCode13 === " ")) {
                    setIsShowMe13(false)
                }
                else {
                    setIsShowMe13(true)
                }

                if ((AcStatus.d_StatusCode14 === " ")) {
                    setIsShowMe14(false)
                }
                else {
                    setIsShowMe14(true)
                }

                if ((AcStatus.d_StatusCode15 === " ")) {
                    setIsShowMe15(false)
                }
                else {
                    setIsShowMe15(true)
                }

                if ((AcStatus.d_StatusCode16 === " ")) {
                    setIsShowMe16(false)
                }
                else {
                    setIsShowMe16(true)
                }
                if ((AcStatus.d_StatusCode17 === " ")) {
                    setIsShowMe17(false)
                }
                else {
                    setIsShowMe17(true)
                }
                if ((AcStatus.d_StatusCode18 === " ")) {
                    setIsShowMe18(false)
                }
                else {
                    setIsShowMe18(true)
                }

                if ((AcStatus.d_StatusCode19 === " ")) {
                    setIsShowMe19(false)
                }
                else {
                    setIsShowMe19(true)
                }

                if ((AcStatus.d_StatusCode20 === " ")) {
                    setIsShowMe20(false)
                }
                else {
                    setIsShowMe20(true)
                }    
 

            } catch (error) {
                utils.showError(error)
            }
        })()
    }, [gsb, AcStatus])

   // AcStatus
    return (
        <div>
            <div className="Row">
                <Button className="Col-1-1" disabled={true} icon="direction-left" onClick={() => onPrevRec()} >Prev</Button>
                <Button className="Col-2-1" disabled={true} icon="add" onClick={() => onNew()} >New</Button>
                <Button className="Col-3-1" icon="edit" onClick={() => onEdit()} >Edit</Button>
              
                <Button className="Col-4-1" disabled={true} icon="delete" onClick={() => setisDeletePress(true) } >Delete</Button>
                <Alert
                        cancelButtonText="Cancel"
                        confirmButtonText="Delete"
                        canEscapeKeyCancel={true}
                        icon="trash"
                        intent={Intent.DANGER}
                        isOpen={isDeletePress}
                        onCancel={ () => setisDeletePress(false) }
                        onConfirm={ () => { onDelete(); setisDeletePress(false) } }
                    >
                        <p>
                            Are you sure to Delete ?
                        </p>
                    </Alert>
                <Button className="Col-5-1" disabled={true} icon="direction-right" onClick={() => onNextRec()} >Next</Button>
               
            </div>
            <div className="Spacing-V-16" />
            <div className="Row">
              
                <FormGroup className="Col-1-1" label="Code">
                    <InputGroup readOnly value={AcStatus.d_StatusCode1} />
                </FormGroup>
                <FormGroup className="Col-2-2" label="Account Status">
                    <InputGroup className="Col-2-2"readOnly value={AcStatus.x_AC_SDESC1} />
                </FormGroup>
                
                {IsShowMe1 && <FormGroup className="Col-4-1" label="Allow Buy" labelFor="InputAllowBuy1">
                    <RadioGroup
                        name="d_x_ALLOW_BUY1"
                        disabled={true}
                        inline={true}
                        selectedValue={AcStatus.x_ALLOW_BUY1}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>   }
               
                {IsShowMe1 && <FormGroup className="Col-5-1" label="Allow Sell" labelFor="InputAllowSell1">
                    <RadioGroup
                        name="d_x_ALLOW_SELL1"
                        disabled={true}
                        inline={true}
                        selectedValue={AcStatus.x_ALLOW_SELL1}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup> }

                {IsShowMe1 &&<FormGroup className="Col-6-1" label="Allow Payment"  >
                    <RadioGroup
                        name="d_x_ALLOW_PYMT1"
                        disabled={true}
                        inline={true}
                        selectedValue={AcStatus.x_ALLOW_PYMT1}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}

                {IsShowMe1 &&<FormGroup className="Col-7-1" label="Allow Recevie"  >
                    <RadioGroup
                        name="d_x_ALLOW_REC1"
                        disabled={true}
                        inline={true}
                        selectedValue={AcStatus.x_ALLOW_REC1}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}

                {IsShowMe1 &&<FormGroup className="Col-8-1" label="Allow Desposit"  >
                    <RadioGroup
                        name="d_x_ALLOW_DEP1"
                        disabled={true}
                        inline={true}
                        selectedValue={AcStatus.x_ALLOW_DEP1}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}

                {IsShowMe1 &&<FormGroup className="Col-9-1" label="Allow Withdrawal"  >
                    <RadioGroup
                        name="d_x_ALLOW_WD1"
                        disabled={true}
                        inline={true}
                        selectedValue={AcStatus.x_ALLOW_WD1}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}                                                                                                         
            </div>
            <div className="Row">
            <FormGroup className="Col-1-1" label="">
                    <InputGroup readOnly value={AcStatus.d_StatusCode2} />
                </FormGroup>
                <FormGroup className="Col-2-2" label="">
                    <InputGroup readOnly value={AcStatus.x_AC_SDESC2} />
                </FormGroup>


                <FormGroup className="Col-4-1"  >
                    <RadioGroup
                        name="d_x_ALLOW_BUY2"
                        disabled={true}
                        inline={true}
                        selectedValue={AcStatus.x_ALLOW_BUY2}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>   
               
                <FormGroup className="Col-5-1"   >
                    <RadioGroup
                        name="d_x_ALLOW_SELL2"
                        disabled={true}
                        inline={true}
                        selectedValue={AcStatus.x_ALLOW_SELL2}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>   
                <FormGroup className="Col-6-1"    >
                    <RadioGroup
                        name="d_x_ALLOW_PYMT2"
                        disabled={true}
                        inline={true}
                        selectedValue={AcStatus.x_ALLOW_PYMT2}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>

                <FormGroup className="Col-7-1"   >
                    <RadioGroup
                        name="d_x_ALLOW_REC2"
                        disabled={true}
                        inline={true}
                        selectedValue={AcStatus.x_ALLOW_REC2}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>

                <FormGroup className="Col-8-1"   >
                    <RadioGroup
                        name="d_x_ALLOW_DEP2"
                        disabled={true}
                        inline={true}
                        selectedValue={AcStatus.x_ALLOW_DEP2}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>

                <FormGroup className="Col-9-1"   >
                    <RadioGroup
                        name="d_x_ALLOW_WD2"
                        disabled={true}
                        inline={true}
                        selectedValue={AcStatus.x_ALLOW_WD2}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup> 

            </div>
            <div className="Row">
            <FormGroup className="Col-1-1" label="">
                    <InputGroup readOnly value={AcStatus.d_StatusCode3} />
                </FormGroup>
                <FormGroup className="Col-2-2" label="">
                    <InputGroup readOnly value={AcStatus.x_AC_SDESC3} />
                </FormGroup>
                <FormGroup className="Col-4-1"  >
                    <RadioGroup
                        name="d_x_ALLOW_BUY3"
                        disabled={true}
                        inline={true}
                        selectedValue={AcStatus.x_ALLOW_BUY3}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>

                <FormGroup className="Col-5-1"   >
                    <RadioGroup
                        name="d_x_ALLOW_SELL3"
                        disabled={true}
                        inline={true}
                        selectedValue={AcStatus.x_ALLOW_SELL3}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>
                <FormGroup className="Col-6-1"    >
                    <RadioGroup
                        name="d_x_ALLOW_PYMT3"
                        disabled={true}
                        inline={true}
                        selectedValue={AcStatus.x_ALLOW_PYMT3}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>

                <FormGroup className="Col-7-1"   >
                    <RadioGroup
                        name="d_x_ALLOW_REC3"
                        disabled={true}
                        inline={true}
                        selectedValue={AcStatus.x_ALLOW_REC3}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>

                <FormGroup className="Col-8-1"   >
                    <RadioGroup
                        name="d_x_ALLOW_DEP3"
                        disabled={true}
                        inline={true}
                        selectedValue={AcStatus.x_ALLOW_DEP3}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>

                <FormGroup className="Col-9-1"   >
                    <RadioGroup
                        name="d_x_ALLOW_WD3"
                        disabled={true}
                        inline={true}
                        selectedValue={AcStatus.x_ALLOW_WD3}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>                 
            </div>
            <div className="Row">
            <FormGroup className="Col-1-1" label="">
                    <InputGroup readOnly value={AcStatus.d_StatusCode4} />
                </FormGroup>
                <FormGroup className="Col-2-2" label="">
                    <InputGroup readOnly value={AcStatus.x_AC_SDESC4} />
                </FormGroup>
                {IsShowMe4 === true && <FormGroup className="Col-4-1"  >
                    <RadioGroup
                        name="d_x_ALLOW_BUY4"
                        disabled={true}
                        inline={true}
                        selectedValue={AcStatus.x_ALLOW_BUY4}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}
                {IsShowMe4=== true && <FormGroup className="Col-5-1"   >
                    <RadioGroup
                        name="d_x_ALLOW_SELL4"
                        disabled={true}
                        inline={true}
                        selectedValue={AcStatus.x_ALLOW_SELL4}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}
                {IsShowMe4 === true && <FormGroup className="Col-6-1"    >
                    <RadioGroup
                        name="d_x_ALLOW_PYMT4"
                        disabled={true}
                        inline={true}
                        selectedValue={AcStatus.x_ALLOW_PYMT4}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}

                {IsShowMe4 === true && <FormGroup className="Col-7-1"   >
                    <RadioGroup
                        name="d_x_ALLOW_REC4"
                        disabled={true}
                        inline={true}
                        selectedValue={AcStatus.x_ALLOW_REC4}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}

                {IsShowMe4 === true && <FormGroup className="Col-8-1"   >
                    <RadioGroup
                        name="d_x_ALLOW_DEP4"
                        disabled={true}
                        inline={true}
                        selectedValue={AcStatus.x_ALLOW_DEP4}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}

                {IsShowMe4 === true && <FormGroup className="Col-9-1"   >
                    <RadioGroup
                        name="d_x_ALLOW_WD4"
                        disabled={true}
                        inline={true}
                        selectedValue={AcStatus.x_ALLOW_WD4}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}                 
            </div>
            <div className="Row">
                <FormGroup className="Col-1-1" label="">
                    <InputGroup readOnly value={AcStatus.d_StatusCode5} />
                </FormGroup>
                <FormGroup className="Col-2-2"  >
                    <InputGroup readOnly value={AcStatus.x_AC_SDESC5} />
                </FormGroup>
            
         
                {IsShowMe5=== true &&<FormGroup className="Col-4-1"  >
                    <RadioGroup
                        name="d_x_ALLOW_BUY5"
                        disabled={true}
                        inline={true}
                        selectedValue={AcStatus.x_ALLOW_BUY5}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>} 
               
                {IsShowMe5 &&<FormGroup className="Col-5-1"   >
                    <RadioGroup
                        name="d_x_ALLOW_SELL5"
                        disabled={true}
                        inline={true}
                        selectedValue={AcStatus.x_ALLOW_SELL5}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}
                           
                {IsShowMe5 && <FormGroup className="Col-6-1"    >
                    <RadioGroup
                        name="d_x_ALLOW_PYMT5"
                        disabled={true}
                        inline={true}
                        selectedValue={AcStatus.x_ALLOW_PYMT5}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>} 
               
                {IsShowMe5 &&<FormGroup className="Col-7-1"   >
                    <RadioGroup
                        name="d_x_ALLOW_REC5"
                        disabled={true}
                        inline={true}
                        selectedValue={AcStatus.x_ALLOW_REC5}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}
               
                {IsShowMe5 &&<FormGroup className="Col-8-1"   >
                    <RadioGroup
                        name="d_x_ALLOW_DEP5"
                        disabled={true}
                        inline={true}
                        selectedValue={AcStatus.x_ALLOW_DEP5}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}

                {IsShowMe5 && <FormGroup className="Col-9-1"   >
                    <RadioGroup
                        name="d_x_ALLOW_WD5"
                        disabled={true}
                        inline={true}
                        selectedValue={AcStatus.x_ALLOW_WD5}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}
            </div>
           
            <div className="Row">
            <FormGroup className="Col-1-1" label="">
                    <InputGroup readOnly value={AcStatus.d_StatusCode6} />
                </FormGroup>
                <FormGroup className="Col-2-2" label="">
                    <InputGroup readOnly value={AcStatus.x_AC_SDESC6} />
                </FormGroup>
                {IsShowMe6 &&<FormGroup className="Col-4-1"  >
                    <RadioGroup
                        name="d_x_ALLOW_BUY6"
                        disabled={true}
                        inline={true}
                        selectedValue={AcStatus.x_ALLOW_BUY6}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}

                {IsShowMe6 && <FormGroup className="Col-5-1"   >
                    <RadioGroup
                        name="d_x_ALLOW_SELL6"
                        disabled={true}
                        inline={true}
                        selectedValue={AcStatus.x_ALLOW_SELL6}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}
                {IsShowMe6 && <FormGroup className="Col-6-1"    >
                    <RadioGroup
                        name="d_x_ALLOW_PYMT6"
                        disabled={true}
                        inline={true}
                        selectedValue={AcStatus.x_ALLOW_PYMT6}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}

                {IsShowMe6 && <FormGroup className="Col-7-1"   >
                    <RadioGroup
                        name="d_x_ALLOW_REC6"
                        disabled={true}
                        inline={true}
                        selectedValue={AcStatus.x_ALLOW_REC6}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}

                {IsShowMe6 && <FormGroup className="Col-8-1"   >
                    <RadioGroup
                        name="d_x_ALLOW_DEP6"
                        disabled={true}
                        inline={true}
                        selectedValue={AcStatus.x_ALLOW_DEP6}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}

                {IsShowMe6 && <FormGroup className="Col-9-1"   >
                    <RadioGroup
                        name="d_x_ALLOW_WD6"
                        disabled={true}
                        inline={true}
                        selectedValue={AcStatus.x_ALLOW_WD6}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}                 
            </div>
            <div className="Row">
            <FormGroup className="Col-1-1" label="">
                    <InputGroup readOnly value={AcStatus.d_StatusCode7} />
                </FormGroup>
                <FormGroup className="Col-2-2" label="">
                    <InputGroup readOnly value={AcStatus.x_AC_SDESC7} />
                </FormGroup>
                {IsShowMe7 && <FormGroup className="Col-4-1"  >
                    <RadioGroup
                        name="d_x_ALLOW_BUY7"
                        disabled={true}
                        inline={true}
                        selectedValue={AcStatus.x_ALLOW_BUY7}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}

                {IsShowMe7 && <FormGroup className="Col-5-1"   >
                    <RadioGroup
                        name="d_x_ALLOW_SELL7"
                        disabled={true}
                        inline={true}
                        selectedValue={AcStatus.x_ALLOW_SELL7}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}
                {IsShowMe7 && <FormGroup className="Col-6-1"    >
                    <RadioGroup
                        name="d_x_ALLOW_PYMT7"
                        disabled={true}
                        inline={true}
                        selectedValue={AcStatus.x_ALLOW_PYMT7}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}

                {IsShowMe7 && <FormGroup className="Col-7-1"   >
                    <RadioGroup
                        name="d_x_ALLOW_REC7"
                        disabled={true}
                        inline={true}
                        selectedValue={AcStatus.x_ALLOW_REC7}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}

                {IsShowMe7 && <FormGroup className="Col-8-1"   >
                    <RadioGroup
                        name="d_x_ALLOW_DEP7"
                        disabled={true}
                        inline={true}
                        selectedValue={AcStatus.x_ALLOW_DEP7}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}

                {IsShowMe7 && <FormGroup className="Col-9-1"   >
                    <RadioGroup
                        name="d_x_ALLOW_WD7"
                        disabled={true}
                        inline={true}
                        selectedValue={AcStatus.x_ALLOW_WD7}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup> }
            </div>
            <div className="Row">
            <FormGroup className="Col-1-1" label="">
                    <InputGroup readOnly value={AcStatus.d_StatusCode8} />
                </FormGroup>
                <FormGroup className="Col-2-2" label="">
                    <InputGroup readOnly value={AcStatus.x_AC_SDESC8} />
                </FormGroup>
                {IsShowMe8 && <FormGroup className="Col-4-1"  >
                    <RadioGroup
                        name="d_x_ALLOW_BUY8"
                        disabled={true}
                        inline={true}
                        selectedValue={AcStatus.x_ALLOW_BUY8}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}

                {IsShowMe8 && <FormGroup className="Col-5-1"   >
                    <RadioGroup
                        name="d_x_ALLOW_SELL8"
                        disabled={true}
                        inline={true}
                        selectedValue={AcStatus.x_ALLOW_SELL8}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}
                {IsShowMe8 && <FormGroup className="Col-6-1"    >
                    <RadioGroup
                        name="d_x_ALLOW_PYMT8"
                        disabled={true}
                        inline={true}
                        selectedValue={AcStatus.x_ALLOW_PYMT8}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}

                {IsShowMe8 && <FormGroup className="Col-7-1"   >
                    <RadioGroup
                        name="d_x_ALLOW_REC8"
                        disabled={true}
                        inline={true}
                        selectedValue={AcStatus.x_ALLOW_REC8}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}

                {IsShowMe8 && <FormGroup className="Col-8-1"   >
                    <RadioGroup
                        name="d_x_ALLOW_DEP8"
                        disabled={true}
                        inline={true}
                        selectedValue={AcStatus.x_ALLOW_DEP8}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}

                {IsShowMe8 && <FormGroup className="Col-9-1"   >
                    <RadioGroup
                        name="d_x_ALLOW_WD8"
                        disabled={true}
                        inline={true}
                        selectedValue={AcStatus.x_ALLOW_WD8}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}                
            </div>
            <div className="Row">
            <FormGroup className="Col-1-1" label="">
                    <InputGroup readOnly value={AcStatus.d_StatusCode9} />
                </FormGroup>
                <FormGroup className="Col-2-2" label="">
                    <InputGroup readOnly value={AcStatus.x_AC_SDESC9} />
                </FormGroup>
                {IsShowMe9 && <FormGroup className="Col-4-1"  >
                    <RadioGroup
                        name="d_x_ALLOW_BUY9"
                        disabled={true}
                        inline={true}
                        selectedValue={AcStatus.x_ALLOW_BUY9}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}

                {IsShowMe9 && <FormGroup className="Col-5-1"   >
                    <RadioGroup
                        name="d_x_ALLOW_SELL9"
                        disabled={true}
                        inline={true}
                        selectedValue={AcStatus.x_ALLOW_SELL9}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}
                {IsShowMe9 && <FormGroup className="Col-6-1"    >
                    <RadioGroup
                        name="d_x_ALLOW_PYMT9"
                        disabled={true}
                        inline={true}
                        selectedValue={AcStatus.x_ALLOW_PYMT9}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}

                {IsShowMe9 && <FormGroup className="Col-7-1"   >
                    <RadioGroup
                        name="d_x_ALLOW_REC9"
                        disabled={true}
                        inline={true}
                        selectedValue={AcStatus.x_ALLOW_REC9}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}

                {IsShowMe9 && <FormGroup className="Col-8-1"   >
                    <RadioGroup
                        name="d_x_ALLOW_DEP9"
                        disabled={true}
                        inline={true}
                        selectedValue={AcStatus.x_ALLOW_DEP9}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}

                {IsShowMe9 && <FormGroup className="Col-9-1"   >
                    <RadioGroup
                        name="d_x_ALLOW_WD9"
                        disabled={true}
                        inline={true}
                        selectedValue={AcStatus.x_ALLOW_WD9}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup> }


            </div>
            <div className="Row">
            <FormGroup className="Col-1-1" label="">
                    <InputGroup readOnly value={AcStatus.d_StatusCode10} />
                </FormGroup>
                <FormGroup className="Col-2-2" label="">
                    <InputGroup readOnly value={AcStatus.x_AC_SDESC10} />
                </FormGroup>
                {IsShowMe10 && <FormGroup className="Col-4-1"  >
                    <RadioGroup
                        name="d_x_ALLOW_BUY10"
                        disabled={true}
                        inline={true}
                        selectedValue={AcStatus.x_ALLOW_BUY10}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}

                {IsShowMe10 && <FormGroup className="Col-5-1"   >
                    <RadioGroup
                        name="d_x_ALLOW_SELL10"
                        disabled={true}
                        inline={true}
                        selectedValue={AcStatus.x_ALLOW_SELL10}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}
                {IsShowMe10 && <FormGroup className="Col-6-1"    >
                    <RadioGroup
                        name="d_x_ALLOW_PYMT10"
                        disabled={true}
                        inline={true}
                        selectedValue={AcStatus.x_ALLOW_PYMT10}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}

                {IsShowMe10 && <FormGroup className="Col-7-1"   >
                    <RadioGroup
                        name="d_x_ALLOW_REC10"
                        disabled={true}
                        inline={true}
                        selectedValue={AcStatus.x_ALLOW_REC10}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}

                {IsShowMe10 && <FormGroup className="Col-8-1"   >
                    <RadioGroup
                        name="d_x_ALLOW_DEP10"
                        disabled={true}
                        inline={true}
                        selectedValue={AcStatus.x_ALLOW_DEP10}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}

                {IsShowMe10 && <FormGroup className="Col-9-1"   >
                    <RadioGroup
                        name="d_x_ALLOW_WD10"
                        disabled={true}
                        inline={true}
                        selectedValue={AcStatus.x_ALLOW_WD10}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}                 
            </div>
            <div className="Row">
            <FormGroup className="Col-1-1" label="">
                    <InputGroup readOnly value={AcStatus.d_StatusCode11} />
                </FormGroup>
                <FormGroup className="Col-2-2" label="">
                    <InputGroup readOnly value={AcStatus.x_AC_SDESC11} />
                </FormGroup>
                {IsShowMe11 && <FormGroup className="Col-4-1"  >
                    <RadioGroup
                        name="d_x_ALLOW_BUY11"
                        disabled={true}
                        inline={true}
                        selectedValue={AcStatus.x_ALLOW_BUY11}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}

                {IsShowMe11 && <FormGroup className="Col-5-1"   >
                    <RadioGroup
                        name="d_x_ALLOW_SELL11"
                        disabled={true}
                        inline={true}
                        selectedValue={AcStatus.x_ALLOW_SELL11}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}
                {IsShowMe11 && <FormGroup className="Col-6-1"    >
                    <RadioGroup
                        name="d_x_ALLOW_PYMT11"
                        disabled={true}
                        inline={true}
                        selectedValue={AcStatus.x_ALLOW_PYMT11}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}

                {IsShowMe11 && <FormGroup className="Col-7-1"   >
                    <RadioGroup
                        name="d_x_ALLOW_REC11"
                        disabled={true}
                        inline={true}
                        selectedValue={AcStatus.x_ALLOW_REC11}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}

                {IsShowMe11 && <FormGroup className="Col-8-1"   >
                    <RadioGroup
                        name="d_x_ALLOW_DEP11"
                        disabled={true}
                        inline={true}
                        selectedValue={AcStatus.x_ALLOW_DEP11}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}

                {IsShowMe11 && <FormGroup className="Col-9-1"   >
                    <RadioGroup
                        name="d_x_ALLOW_WD11"
                        disabled={true}
                        inline={true}
                        selectedValue={AcStatus.x_ALLOW_WD11}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}
            </div>
            <div className="Row">
            <FormGroup className="Col-1-1" label="">
                    <InputGroup readOnly value={AcStatus.d_StatusCode12} />
                </FormGroup>
                <FormGroup className="Col-2-2" label="">
                    <InputGroup readOnly value={AcStatus.x_AC_SDESC12} />
                </FormGroup>
                {IsShowMe12 && <FormGroup className="Col-4-1"  >
                    <RadioGroup
                        name="d_x_ALLOW_BUY12"
                        disabled={true}
                        inline={true}
                        selectedValue={AcStatus.x_ALLOW_BUY12}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}

                {IsShowMe12 &&<FormGroup className="Col-5-1"   >
                    <RadioGroup
                        name="d_x_ALLOW_SELL12"
                        disabled={true}
                        inline={true}
                        selectedValue={AcStatus.x_ALLOW_SELL12}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}
                {IsShowMe12 &&<FormGroup className="Col-6-1"    >
                    <RadioGroup
                        name="d_x_ALLOW_PYMT12"
                        disabled={true}
                        inline={true}
                        selectedValue={AcStatus.x_ALLOW_PYMT12}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}

                {IsShowMe12 &&<FormGroup className="Col-7-1"   >
                    <RadioGroup
                        name="d_x_ALLOW_REC12"
                        disabled={true}
                        inline={true}
                        selectedValue={AcStatus.x_ALLOW_REC12}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}

                {IsShowMe12 &&<FormGroup className="Col-8-1"   >
                    <RadioGroup
                        name="d_x_ALLOW_DEP12"
                        disabled={true}
                        inline={true}
                        selectedValue={AcStatus.x_ALLOW_DEP12}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}

                {IsShowMe12 &&<FormGroup className="Col-9-1"   >
                    <RadioGroup
                        name="d_x_ALLOW_WD12"
                        disabled={true}
                        inline={true}
                        selectedValue={AcStatus.x_ALLOW_WD12}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}                 
            </div>
            <div className="Row">
            <FormGroup className="Col-1-1" label="">
                    <InputGroup readOnly value={AcStatus.d_StatusCode13} />
                </FormGroup>
                <FormGroup className="Col-2-2" label="">
                    <InputGroup readOnly value={AcStatus.x_AC_SDESC13} />
                </FormGroup>
                {IsShowMe13 && <FormGroup className="Col-4-1"  >
                    <RadioGroup
                        name="d_x_ALLOW_BUY13"
                        disabled={true}
                        inline={true}
                        selectedValue={AcStatus.x_ALLOW_BUY13}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}

                {IsShowMe13 && <FormGroup className="Col-5-1"   >
                    <RadioGroup
                        name="d_x_ALLOW_SELL13"
                        disabled={true}
                        inline={true}
                        selectedValue={AcStatus.x_ALLOW_SELL13}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}
                {IsShowMe13 && <FormGroup className="Col-6-1"    >
                    <RadioGroup
                        name="d_x_ALLOW_PYMT13"
                        disabled={true}
                        inline={true}
                        selectedValue={AcStatus.x_ALLOW_PYMT13}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}

                {IsShowMe13 && <FormGroup className="Col-7-1"   >
                    <RadioGroup
                        name="d_x_ALLOW_REC13"
                        disabled={true}
                        inline={true}
                        selectedValue={AcStatus.x_ALLOW_REC13}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}

                {IsShowMe13 && <FormGroup className="Col-8-1"   >
                    <RadioGroup
                        name="d_x_ALLOW_DEP13"
                        disabled={true}
                        inline={true}
                        selectedValue={AcStatus.x_ALLOW_DEP13}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}

                {IsShowMe13 && <FormGroup className="Col-9-1"   >
                    <RadioGroup
                        name="d_x_ALLOW_WD13"
                        disabled={true}
                        inline={true}
                        selectedValue={AcStatus.x_ALLOW_WD13}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}                
            </div>
            <div className="Row">
            <FormGroup className="Col-1-1" label="">
                    <InputGroup readOnly value={AcStatus.d_StatusCode14} />
                </FormGroup>
                <FormGroup className="Col-2-2" label="">
                    <InputGroup readOnly value={AcStatus.x_AC_SDESC14} />
                </FormGroup>
                {IsShowMe14 && <FormGroup className="Col-4-1"  >
                    <RadioGroup
                        name="d_x_ALLOW_BUY14"
                        disabled={true}
                        inline={true}
                        selectedValue={AcStatus.x_ALLOW_BUY14}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}

                {IsShowMe14 && <FormGroup className="Col-5-1"   >
                    <RadioGroup
                        name="d_x_ALLOW_SELL14"
                        disabled={true}
                        inline={true}
                        selectedValue={AcStatus.x_ALLOW_SELL14}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}
                {IsShowMe14 && <FormGroup className="Col-6-1"    >
                    <RadioGroup
                        name="d_x_ALLOW_PYMT14"
                        disabled={true}
                        inline={true}
                        selectedValue={AcStatus.x_ALLOW_PYMT14}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}

                {IsShowMe14 && <FormGroup className="Col-7-1"   >
                    <RadioGroup
                        name="d_x_ALLOW_REC14"
                        disabled={true}
                        inline={true}
                        selectedValue={AcStatus.x_ALLOW_REC14}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}

                {IsShowMe14 && <FormGroup className="Col-8-1"   >
                    <RadioGroup
                        name="d_x_ALLOW_DEP14"
                        disabled={true}
                        inline={true}
                        selectedValue={AcStatus.x_ALLOW_DEP14}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}

                {IsShowMe14 && <FormGroup className="Col-9-1"   >
                    <RadioGroup
                        name="d_x_ALLOW_WD14"
                        disabled={true}
                        inline={true}
                        selectedValue={AcStatus.x_ALLOW_WD14}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}            
            </div>
            <div className="Row">
            <FormGroup className="Col-1-1" label="">
                    <InputGroup readOnly value={AcStatus.d_StatusCode15} />
                </FormGroup>
                <FormGroup className="Col-2-2" label="">
                    <InputGroup readOnly value={AcStatus.x_AC_SDESC15} />
                </FormGroup>
                {IsShowMe15 && <FormGroup className="Col-4-1"  >
                    <RadioGroup
                        name="d_x_ALLOW_BUY15"
                        disabled={true}
                        inline={true}
                        selectedValue={AcStatus.x_ALLOW_BUY15}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}

                {IsShowMe15 && <FormGroup className="Col-5-1"   >
                    <RadioGroup
                        name="d_x_ALLOW_SELL15"
                        disabled={true}
                        inline={true}
                        selectedValue={AcStatus.x_ALLOW_SELL15}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}
                {IsShowMe15 && <FormGroup className="Col-6-1"    >
                    <RadioGroup
                        name="d_x_ALLOW_PYMT15"
                        disabled={true}
                        inline={true}
                        selectedValue={AcStatus.x_ALLOW_PYMT15}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}

                {IsShowMe15 && <FormGroup className="Col-7-1"   >
                    <RadioGroup
                        name="d_x_ALLOW_REC15"
                        disabled={true}
                        inline={true}
                        selectedValue={AcStatus.x_ALLOW_REC15}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}

                {IsShowMe15 && <FormGroup className="Col-8-1"   >
                    <RadioGroup
                        name="d_x_ALLOW_DEP15"
                        disabled={true}
                        inline={true}
                        selectedValue={AcStatus.x_ALLOW_DEP15}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}

                {IsShowMe15 && <FormGroup className="Col-9-1"   >
                    <RadioGroup
                        name="d_x_ALLOW_WD15"
                        disabled={true}
                        inline={true}
                        selectedValue={AcStatus.x_ALLOW_WD15}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}               
            </div>
            <div className="Row">
            <FormGroup className="Col-1-1" label="">
                    <InputGroup readOnly value={AcStatus.d_StatusCode16} />
                </FormGroup>
                <FormGroup className="Col-2-2" label="">
                    <InputGroup readOnly value={AcStatus.x_AC_SDESC16} />
                </FormGroup>
                {IsShowMe16 && <FormGroup className="Col-4-1"  >
                    <RadioGroup
                        name="d_x_ALLOW_BUY16"
                        disabled={true}
                        inline={true}
                        selectedValue={AcStatus.x_ALLOW_BUY16}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}

                {IsShowMe16 && <FormGroup className="Col-5-1"   >
                    <RadioGroup
                        name="d_x_ALLOW_SELL16"
                        disabled={true}
                        inline={true}
                        selectedValue={AcStatus.x_ALLOW_SELL16}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}
                {IsShowMe16 && <FormGroup className="Col-6-1"    >
                    <RadioGroup
                        name="d_x_ALLOW_PYMT16"
                        disabled={true}
                        inline={true}
                        selectedValue={AcStatus.x_ALLOW_PYMT16}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}

                {IsShowMe16 && <FormGroup className="Col-7-1"   >
                    <RadioGroup
                        name="d_x_ALLOW_REC16"
                        disabled={true}
                        inline={true}
                        selectedValue={AcStatus.x_ALLOW_REC16}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}

                {IsShowMe16 && <FormGroup className="Col-8-1"   >
                    <RadioGroup
                        name="d_x_ALLOW_DEP16"
                        disabled={true}
                        inline={true}
                        selectedValue={AcStatus.x_ALLOW_DEP16}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}

                {IsShowMe16 && <FormGroup className="Col-9-1"   >
                    <RadioGroup
                        name="d_x_ALLOW_WD16"
                        disabled={true}
                        inline={true}
                        selectedValue={AcStatus.x_ALLOW_WD16}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}               
            </div>
            <div className="Row">
            <FormGroup className="Col-1-1" label="">
                    <InputGroup readOnly value={AcStatus.d_StatusCode17} />
                </FormGroup>
                <FormGroup className="Col-2-2" label="">
                    <InputGroup readOnly value={AcStatus.x_AC_SDESC17} />
                </FormGroup>
                {IsShowMe17 && <FormGroup className="Col-4-1"  >
                    <RadioGroup
                        name="d_x_ALLOW_BUY17"
                        disabled={true}
                        inline={true}
                        selectedValue={AcStatus.x_ALLOW_BUY17}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}

                {IsShowMe17 && <FormGroup className="Col-5-1"   >
                    <RadioGroup
                        name="d_x_ALLOW_SELL17"
                        disabled={true}
                        inline={true}
                        selectedValue={AcStatus.x_ALLOW_SELL17}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}
                {IsShowMe17 && <FormGroup className="Col-6-1"    >
                    <RadioGroup
                        name="d_x_ALLOW_PYMT17"
                        disabled={true}
                        inline={true}
                        selectedValue={AcStatus.x_ALLOW_PYMT17}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}

                {IsShowMe17 && <FormGroup className="Col-7-1"   >
                    <RadioGroup
                        name="d_x_ALLOW_REC17"
                        disabled={true}
                        inline={true}
                        selectedValue={AcStatus.x_ALLOW_REC17}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}

                {IsShowMe17 && <FormGroup className="Col-8-1"   >
                    <RadioGroup
                        name="d_x_ALLOW_DEP17"
                        disabled={true}
                        inline={true}
                        selectedValue={AcStatus.x_ALLOW_DEP17}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}

                {IsShowMe17 && <FormGroup className="Col-9-1"   >
                    <RadioGroup
                        name="d_x_ALLOW_WD17"
                        disabled={true}
                        inline={true}
                        selectedValue={AcStatus.x_ALLOW_WD17}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}                 
            </div>
            <div className="Row">
            <FormGroup className="Col-1-1" label="">
                    <InputGroup readOnly value={AcStatus.d_StatusCode18} />
                </FormGroup>
                <FormGroup className="Col-2-2" label="">
                    <InputGroup readOnly value={AcStatus.x_AC_SDESC18} />
                </FormGroup>
                {IsShowMe18 &&<FormGroup className="Col-4-1"  >
                    <RadioGroup
                        name="d_x_ALLOW_BUY18"
                        disabled={true}
                        inline={true}
                        selectedValue={AcStatus.x_ALLOW_BUY18}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}

                {IsShowMe18 &&<FormGroup className="Col-5-1"   >
                    <RadioGroup
                        name="d_x_ALLOW_SELL18"
                        disabled={true}
                        inline={true}
                        selectedValue={AcStatus.x_ALLOW_SELL18}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}
                {IsShowMe18 &&<FormGroup className="Col-6-1"    >
                    <RadioGroup
                        name="d_x_ALLOW_PYMT18"
                        disabled={true}
                        inline={true}
                        selectedValue={AcStatus.x_ALLOW_PYMT18}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}

                {IsShowMe18 &&<FormGroup className="Col-7-1"   >
                    <RadioGroup
                        name="d_x_ALLOW_REC18"
                        disabled={true}
                        inline={true}
                        selectedValue={AcStatus.x_ALLOW_REC18}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}

                {IsShowMe18 &&<FormGroup className="Col-8-1"   >
                    <RadioGroup
                        name="d_x_ALLOW_DEP18"
                        disabled={true}
                        inline={true}
                        selectedValue={AcStatus.x_ALLOW_DEP18}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}
                {IsShowMe18 && <FormGroup className="Col-9-1"   >
                    <RadioGroup
                        name="d_x_ALLOW_WD18"
                        disabled={true}
                        inline={true}
                        selectedValue={AcStatus.x_ALLOW_WD18}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}         
            </div>
            <div className="Row">
            <FormGroup className="Col-1-1" label="">
                    <InputGroup readOnly value={AcStatus.d_StatusCode19} />
                </FormGroup>
                <FormGroup className="Col-2-2" label="">
                    <InputGroup readOnly value={AcStatus.x_AC_SDESC19} />
                </FormGroup>
                {IsShowMe19 && <FormGroup className="Col-4-1"  >
                    <RadioGroup
                        name="d_x_ALLOW_BUY19"
                        disabled={true}
                        inline={true}
                        selectedValue={AcStatus.x_ALLOW_BUY19}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}

                {IsShowMe19 && <FormGroup className="Col-5-1"   >
                    <RadioGroup
                        name="d_x_ALLOW_SELL19"
                        disabled={true}
                        inline={true}
                        selectedValue={AcStatus.x_ALLOW_SELL19}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}
                {IsShowMe19 && <FormGroup className="Col-6-1"    >
                    <RadioGroup
                        name="d_x_ALLOW_PYMT19"
                        disabled={true}
                        inline={true}
                        selectedValue={AcStatus.x_ALLOW_PYMT19}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}

                {IsShowMe19 && <FormGroup className="Col-7-1"   >
                    <RadioGroup
                        name="d_x_ALLOW_REC19"
                        disabled={true}
                        inline={true}
                        selectedValue={AcStatus.x_ALLOW_REC19}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}

                {IsShowMe19 && <FormGroup className="Col-8-1"   >
                    <RadioGroup
                        name="d_x_ALLOW_DEP19"
                        disabled={true}
                        inline={true}
                        selectedValue={AcStatus.x_ALLOW_DEP19}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}

                {IsShowMe19 && <FormGroup className="Col-9-1"   >
                    <RadioGroup
                        name="d_x_ALLOW_WD19"
                        disabled={true}
                        inline={true}
                        selectedValue={AcStatus.x_ALLOW_WD19}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}                 
            </div>
            <div className="Row">
            <FormGroup className="Col-1-1" label="">
                    <InputGroup readOnly value={AcStatus.d_StatusCode20} />
                </FormGroup>
                <FormGroup className="Col-2-2" label="">
                    <InputGroup readOnly value={AcStatus.x_AC_SDESC20} />
                </FormGroup>
                {IsShowMe20 && <FormGroup className="Col-4-1"  >
                    <RadioGroup
                        name="d_x_ALLOW_BUY20"
                        disabled={true}
                        inline={true}
                        selectedValue={AcStatus.x_ALLOW_BUY20}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}

                {IsShowMe20 && <FormGroup className="Col-5-1"   >
                    <RadioGroup
                        name="d_x_ALLOW_SELL20"
                        disabled={true}
                        inline={true}
                        selectedValue={AcStatus.x_ALLOW_SELL20}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}
                {IsShowMe20 && <FormGroup className="Col-6-1"    >
                    <RadioGroup
                        name="d_x_ALLOW_PYMT20"
                        disabled={true}
                        inline={true}
                        selectedValue={AcStatus.x_ALLOW_PYMT20}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}

                {IsShowMe20 && <FormGroup className="Col-7-1"   >
                    <RadioGroup
                        name="d_x_ALLOW_REC20"
                        disabled={true}
                        inline={true}
                        selectedValue={AcStatus.x_ALLOW_REC20}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}

                {IsShowMe20 && <FormGroup className="Col-8-1"   >
                    <RadioGroup
                        name="d_x_ALLOW_DEP20"
                        disabled={true}
                        inline={true}
                        selectedValue={AcStatus.x_ALLOW_DEP20}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}

                {IsShowMe20 && <FormGroup className="Col-9-1"   >
                    <RadioGroup
                        name="d_x_ALLOW_WD20"
                        disabled={true}
                        inline={true}
                        selectedValue={AcStatus.x_ALLOW_WD20}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup> }                
            </div>

        </div>
    )
}

interface AcStatusEditProps {
    gsb: AxiosInstance,
    AcStatus?: AcStatusInfo,
    isNew?: boolean,
    onSave?: (AcStatus: AcStatusInfo) => void,
    onCancel?: () => void;
}

function AcStatusEdit({ gsb, AcStatus = {} as AcStatusInfo, isNew = false, onSave = () => { }, onCancel = () => { } }: AcStatusEditProps) {

    const { register, handleSubmit, reset, setValue, setError, errors } = useForm<AcStatusInfo>()
  
       // console.log("AcStatus", AcStatus)

        //(RESR_Code.indexOf(AcStatus.x_AC_SDESC1) >= 0
       //const [IsNotALLOW1, setIsNotALLOW1] = useState((RESR_Code_noShow.indexOf(AcStatus.d_StatusCode1) >= 0))
        const [def_d_x_ALLOW_BUY1, setdef_d_x_ALLOW_BUY1] = useState(AcStatus.x_ALLOW_BUY1)
        const [def_d_x_ALLOW_SELL1, setdef_d_x_ALLOW_SELL1] = useState(AcStatus.x_ALLOW_SELL1)
       
        const [def_d_x_ALLOW_PYMT1, setdef_d_x_ALLOW_PYMT1] = useState(AcStatus.x_ALLOW_PYMT1)
        const [def_d_x_ALLOW_REC1, setdef_d_x_ALLOW_REC1] = useState(AcStatus.x_ALLOW_REC1)
        const [def_d_x_ALLOW_DEP1, setdef_d_x_ALLOW_DEP1] = useState(AcStatus.x_ALLOW_DEP1)
        const [def_d_x_ALLOW_WD1, setdef_d_x_ALLOW_WD1] = useState(AcStatus.x_ALLOW_WD1)
    
       // const [IsNotALLOW2, setIsNotALLOW2] = useState((RESR_Code.indexOf(AcStatus.x_AC_SDESC2) >= 0))
        const [def_d_x_ALLOW_BUY2, setdef_d_x_ALLOW_BUY2] = useState(AcStatus.x_ALLOW_BUY2)
        const [def_d_x_ALLOW_SELL2, setdef_d_x_ALLOW_SELL2] = useState(AcStatus.x_ALLOW_SELL2)
        const [def_d_x_ALLOW_PYMT2, setdef_d_x_ALLOW_PYMT2] = useState(AcStatus.x_ALLOW_PYMT2)
        const [def_d_x_ALLOW_REC2, setdef_d_x_ALLOW_REC2] = useState(AcStatus.x_ALLOW_REC2)
        const [def_d_x_ALLOW_DEP2, setdef_d_x_ALLOW_DEP2] = useState(AcStatus.x_ALLOW_DEP2)
        const [def_d_x_ALLOW_WD2, setdef_d_x_ALLOW_WD2] = useState(AcStatus.x_ALLOW_WD2)
    
       // const [IsNotALLOW3, setIsNotALLOW3] = useState((RESR_Code.indexOf(AcStatus.x_AC_SDESC3) >= 0))
        const [def_d_x_ALLOW_BUY3, setdef_d_x_ALLOW_BUY3] = useState(AcStatus.x_ALLOW_BUY3)
        const [def_d_x_ALLOW_SELL3, setdef_d_x_ALLOW_SELL3] = useState(AcStatus.x_ALLOW_SELL3)
        const [def_d_x_ALLOW_PYMT3, setdef_d_x_ALLOW_PYMT3] = useState(AcStatus.x_ALLOW_PYMT3)
        const [def_d_x_ALLOW_REC3, setdef_d_x_ALLOW_REC3] = useState(AcStatus.x_ALLOW_REC3)
        const [def_d_x_ALLOW_DEP3, setdef_d_x_ALLOW_DEP3] = useState(AcStatus.x_ALLOW_DEP3)
        const [def_d_x_ALLOW_WD3, setdef_d_x_ALLOW_WD3] = useState(AcStatus.x_ALLOW_WD3)
    
       // const [IsDisableALLOW4, setIsDisableALLOW4] = useState(true)  //useState((RESR_Code.indexOf(AcStatus.x_AC_SDESC4) >= 0))
        const [def_d_x_ALLOW_BUY4, setdef_d_x_ALLOW_BUY4] = useState(AcStatus.x_ALLOW_BUY4)
        const [def_d_x_ALLOW_SELL4, setdef_d_x_ALLOW_SELL4] = useState(AcStatus.x_ALLOW_SELL4)
        const [def_d_x_ALLOW_PYMT4, setdef_d_x_ALLOW_PYMT4] = useState(AcStatus.x_ALLOW_PYMT4)
        const [def_d_x_ALLOW_REC4, setdef_d_x_ALLOW_REC4] = useState(AcStatus.x_ALLOW_REC4)
        const [def_d_x_ALLOW_DEP4, setdef_d_x_ALLOW_DEP4] = useState(AcStatus.x_ALLOW_DEP4)
        const [def_d_x_ALLOW_WD4, setdef_d_x_ALLOW_WD4] = useState(AcStatus.x_ALLOW_WD4)
    
        //const [IsDisableALLOW5, setIsDisableALLOW5] =  useState(true)  //useState((RESR_Code_noShow.indexOf(AcStatus.d_StatusCode5) === 1?true:false))
        const [def_d_x_ALLOW_BUY5, setdef_d_x_ALLOW_BUY5] = useState(AcStatus.x_ALLOW_BUY5)
        const [def_d_x_ALLOW_SELL5, setdef_d_x_ALLOW_SELL5] = useState(AcStatus.x_ALLOW_SELL5)
        const [def_d_x_ALLOW_PYMT5, setdef_d_x_ALLOW_PYMT5] = useState(AcStatus.x_ALLOW_PYMT5)
        const [def_d_x_ALLOW_REC5, setdef_d_x_ALLOW_REC5] = useState(AcStatus.x_ALLOW_REC5)
        const [def_d_x_ALLOW_DEP5, setdef_d_x_ALLOW_DEP5] = useState(AcStatus.x_ALLOW_DEP5)
        const [def_d_x_ALLOW_WD5, setdef_d_x_ALLOW_WD5] = useState(AcStatus.x_ALLOW_WD5)

       // const [IsNotALLOW6, setIsNotALLOW6] = useState((RESR_Code_noShow.indexOf(AcStatus.d_StatusCode6) === 1 ? true : false))
        const [def_d_x_ALLOW_BUY6, setdef_d_x_ALLOW_BUY6] = useState(AcStatus.x_ALLOW_BUY6)
        const [def_d_x_ALLOW_SELL6, setdef_d_x_ALLOW_SELL6] = useState(AcStatus.x_ALLOW_SELL6)
        const [def_d_x_ALLOW_PYMT6, setdef_d_x_ALLOW_PYMT6] = useState(AcStatus.x_ALLOW_PYMT6)
        const [def_d_x_ALLOW_REC6, setdef_d_x_ALLOW_REC6] = useState(AcStatus.x_ALLOW_REC6)
        const [def_d_x_ALLOW_DEP6, setdef_d_x_ALLOW_DEP6] = useState(AcStatus.x_ALLOW_DEP6)
        const [def_d_x_ALLOW_WD6, setdef_d_x_ALLOW_WD6] = useState(AcStatus.x_ALLOW_WD6)
    
       //  const [IsNotALLOW7, setIsNotALLOW7] = useState((RESR_Code_noShow.indexOf(AcStatus.x_AC_SDESC7) >= 0))
        const [def_d_x_ALLOW_BUY7, setdef_d_x_ALLOW_BUY7] = useState(AcStatus.x_ALLOW_BUY7)
        const [def_d_x_ALLOW_SELL7, setdef_d_x_ALLOW_SELL7] = useState(AcStatus.x_ALLOW_SELL7)
        const [def_d_x_ALLOW_PYMT7, setdef_d_x_ALLOW_PYMT7] = useState(AcStatus.x_ALLOW_PYMT7)
        const [def_d_x_ALLOW_REC7, setdef_d_x_ALLOW_REC7] = useState(AcStatus.x_ALLOW_REC7)
        const [def_d_x_ALLOW_DEP7, setdef_d_x_ALLOW_DEP7] = useState(AcStatus.x_ALLOW_DEP7)
        const [def_d_x_ALLOW_WD7, setdef_d_x_ALLOW_WD7] = useState(AcStatus.x_ALLOW_WD7)
    
       // const [IsNotALLOW8, setIsNotALLOW8] = useState((RESR_Code.indexOf(AcStatus.x_AC_SDESC8) >= 0))        
        const [def_d_x_ALLOW_BUY8, setdef_d_x_ALLOW_BUY8] = useState(AcStatus.x_ALLOW_BUY8)
        const [def_d_x_ALLOW_SELL8, setdef_d_x_ALLOW_SELL8] = useState(AcStatus.x_ALLOW_SELL8)
        const [def_d_x_ALLOW_PYMT8, setdef_d_x_ALLOW_PYMT8] = useState(AcStatus.x_ALLOW_PYMT8)
        const [def_d_x_ALLOW_REC8, setdef_d_x_ALLOW_REC8] = useState(AcStatus.x_ALLOW_REC8)
        const [def_d_x_ALLOW_DEP8, setdef_d_x_ALLOW_DEP8] = useState(AcStatus.x_ALLOW_DEP8)
        const [def_d_x_ALLOW_WD8, setdef_d_x_ALLOW_WD8] = useState(AcStatus.x_ALLOW_WD8)
    
       // const [IsNotALLOW9, setIsNotALLOW9] = useState((RESR_Code_noShow.indexOf(AcStatus.x_AC_SDESC9) >= 0))
        const [def_d_x_ALLOW_BUY9, setdef_d_x_ALLOW_BUY9] = useState(AcStatus.x_ALLOW_BUY9)
        const [def_d_x_ALLOW_SELL9, setdef_d_x_ALLOW_SELL9] = useState(AcStatus.x_ALLOW_SELL9)
        const [def_d_x_ALLOW_PYMT9, setdef_d_x_ALLOW_PYMT9] = useState(AcStatus.x_ALLOW_PYMT9)
        const [def_d_x_ALLOW_REC9, setdef_d_x_ALLOW_REC9] = useState(AcStatus.x_ALLOW_REC9)
        const [def_d_x_ALLOW_DEP9, setdef_d_x_ALLOW_DEP9] = useState(AcStatus.x_ALLOW_DEP9)
        const [def_d_x_ALLOW_WD9, setdef_d_x_ALLOW_WD9] = useState(AcStatus.x_ALLOW_WD9)
        
       // const [IsNotALLOW10, setIsNotALLOW10] = useState((RESR_Code.indexOf(AcStatus.x_AC_SDESC10) >= 0))
        const [def_d_x_ALLOW_BUY10, setdef_d_x_ALLOW_BUY10] = useState(AcStatus.x_ALLOW_BUY10)
        const [def_d_x_ALLOW_SELL10, setdef_d_x_ALLOW_SELL10] = useState(AcStatus.x_ALLOW_SELL10)
        const [def_d_x_ALLOW_PYMT10, setdef_d_x_ALLOW_PYMT10] = useState(AcStatus.x_ALLOW_PYMT10)
        const [def_d_x_ALLOW_REC10, setdef_d_x_ALLOW_REC10] = useState(AcStatus.x_ALLOW_REC10)
        const [def_d_x_ALLOW_DEP10, setdef_d_x_ALLOW_DEP10] = useState(AcStatus.x_ALLOW_DEP10)
        const [def_d_x_ALLOW_WD10, setdef_d_x_ALLOW_WD10] = useState(AcStatus.x_ALLOW_WD10)
    
       // const [IsNotALLOW11, setIsNotALLOW11] = useState((RESR_Code.indexOf(AcStatus.x_AC_SDESC11) >= 0))        
        const [def_d_x_ALLOW_BUY11, setdef_d_x_ALLOW_BUY11] = useState(AcStatus.x_ALLOW_BUY11)
        const [def_d_x_ALLOW_SELL11, setdef_d_x_ALLOW_SELL11] = useState(AcStatus.x_ALLOW_SELL11)
        const [def_d_x_ALLOW_PYMT11, setdef_d_x_ALLOW_PYMT11] = useState(AcStatus.x_ALLOW_PYMT11)
        const [def_d_x_ALLOW_REC11, setdef_d_x_ALLOW_REC11] = useState(AcStatus.x_ALLOW_REC11)
        const [def_d_x_ALLOW_DEP11, setdef_d_x_ALLOW_DEP11] = useState(AcStatus.x_ALLOW_DEP11)
        const [def_d_x_ALLOW_WD11, setdef_d_x_ALLOW_WD11] = useState(AcStatus.x_ALLOW_WD11)
    
       // const [IsNotALLOW12, setIsNotALLOW12] = useState((RESR_Code.indexOf(AcStatus.x_AC_SDESC12) >= 0))         
        const [def_d_x_ALLOW_BUY12, setdef_d_x_ALLOW_BUY12] = useState(AcStatus.x_ALLOW_BUY12)
        const [def_d_x_ALLOW_SELL12, setdef_d_x_ALLOW_SELL12] = useState(AcStatus.x_ALLOW_SELL12)
        const [def_d_x_ALLOW_PYMT12, setdef_d_x_ALLOW_PYMT12] = useState(AcStatus.x_ALLOW_PYMT12)
        const [def_d_x_ALLOW_REC12, setdef_d_x_ALLOW_REC12] = useState(AcStatus.x_ALLOW_REC12)
        const [def_d_x_ALLOW_DEP12, setdef_d_x_ALLOW_DEP12] = useState(AcStatus.x_ALLOW_DEP12)
        const [def_d_x_ALLOW_WD12, setdef_d_x_ALLOW_WD12] = useState(AcStatus.x_ALLOW_WD12)
    
        
         const [def_d_x_ALLOW_BUY13, setdef_d_x_ALLOW_BUY13] = useState(AcStatus.x_ALLOW_BUY13)
        const [def_d_x_ALLOW_SELL13, setdef_d_x_ALLOW_SELL13] = useState(AcStatus.x_ALLOW_SELL13)
        const [def_d_x_ALLOW_PYMT13, setdef_d_x_ALLOW_PYMT13] = useState(AcStatus.x_ALLOW_PYMT13)
        const [def_d_x_ALLOW_REC13, setdef_d_x_ALLOW_REC13] = useState(AcStatus.x_ALLOW_REC13)
        const [def_d_x_ALLOW_DEP13, setdef_d_x_ALLOW_DEP13] = useState(AcStatus.x_ALLOW_DEP13)
        const [def_d_x_ALLOW_WD13, setdef_d_x_ALLOW_WD13] = useState(AcStatus.x_ALLOW_WD13)
    
        const [def_d_x_ALLOW_BUY14, setdef_d_x_ALLOW_BUY14] = useState(AcStatus.x_ALLOW_BUY14)
        const [def_d_x_ALLOW_SELL14, setdef_d_x_ALLOW_SELL14] = useState(AcStatus.x_ALLOW_SELL14)
        const [def_d_x_ALLOW_PYMT14, setdef_d_x_ALLOW_PYMT14] = useState(AcStatus.x_ALLOW_PYMT14)
        const [def_d_x_ALLOW_REC14, setdef_d_x_ALLOW_REC14] = useState(AcStatus.x_ALLOW_REC14)
        const [def_d_x_ALLOW_DEP14, setdef_d_x_ALLOW_DEP14] = useState(AcStatus.x_ALLOW_DEP14)
        const [def_d_x_ALLOW_WD14, setdef_d_x_ALLOW_WD14] = useState(AcStatus.x_ALLOW_WD14)
    
        const [def_d_x_ALLOW_BUY15, setdef_d_x_ALLOW_BUY15] = useState(AcStatus.x_ALLOW_BUY15)
        const [def_d_x_ALLOW_SELL15, setdef_d_x_ALLOW_SELL15] = useState(AcStatus.x_ALLOW_SELL15)
        const [def_d_x_ALLOW_PYMT15, setdef_d_x_ALLOW_PYMT15] = useState(AcStatus.x_ALLOW_PYMT15)
        const [def_d_x_ALLOW_REC15, setdef_d_x_ALLOW_REC15] = useState(AcStatus.x_ALLOW_REC15)
        const [def_d_x_ALLOW_DEP15, setdef_d_x_ALLOW_DEP15] = useState(AcStatus.x_ALLOW_DEP15)
        const [def_d_x_ALLOW_WD15, setdef_d_x_ALLOW_WD15] = useState(AcStatus.x_ALLOW_WD15)
    
        const [def_d_x_ALLOW_BUY16, setdef_d_x_ALLOW_BUY16] = useState(AcStatus.x_ALLOW_BUY16)
        const [def_d_x_ALLOW_SELL16, setdef_d_x_ALLOW_SELL16] = useState(AcStatus.x_ALLOW_SELL16)
        const [def_d_x_ALLOW_PYMT16, setdef_d_x_ALLOW_PYMT16] = useState(AcStatus.x_ALLOW_PYMT16)
        const [def_d_x_ALLOW_REC16, setdef_d_x_ALLOW_REC16] = useState(AcStatus.x_ALLOW_REC16)
        const [def_d_x_ALLOW_DEP16, setdef_d_x_ALLOW_DEP16] = useState(AcStatus.x_ALLOW_DEP16)
        const [def_d_x_ALLOW_WD16, setdef_d_x_ALLOW_WD16] = useState(AcStatus.x_ALLOW_WD16)
        
        const [def_d_x_ALLOW_BUY17, setdef_d_x_ALLOW_BUY17] = useState(AcStatus.x_ALLOW_BUY17)
        const [def_d_x_ALLOW_SELL17, setdef_d_x_ALLOW_SELL17] = useState(AcStatus.x_ALLOW_SELL17)
        const [def_d_x_ALLOW_PYMT17, setdef_d_x_ALLOW_PYMT17] = useState(AcStatus.x_ALLOW_PYMT17)
        const [def_d_x_ALLOW_REC17, setdef_d_x_ALLOW_REC17] = useState(AcStatus.x_ALLOW_REC17)
        const [def_d_x_ALLOW_DEP17, setdef_d_x_ALLOW_DEP17] = useState(AcStatus.x_ALLOW_DEP17)
        const [def_d_x_ALLOW_WD17, setdef_d_x_ALLOW_WD17] = useState(AcStatus.x_ALLOW_WD17)
    
        const [def_d_x_ALLOW_BUY18, setdef_d_x_ALLOW_BUY18] = useState(AcStatus.x_ALLOW_BUY18)
        const [def_d_x_ALLOW_SELL18, setdef_d_x_ALLOW_SELL18] = useState(AcStatus.x_ALLOW_SELL18)
        const [def_d_x_ALLOW_PYMT18, setdef_d_x_ALLOW_PYMT18] = useState(AcStatus.x_ALLOW_PYMT18)
        const [def_d_x_ALLOW_REC18, setdef_d_x_ALLOW_REC18] = useState(AcStatus.x_ALLOW_REC18)
        const [def_d_x_ALLOW_DEP18, setdef_d_x_ALLOW_DEP18] = useState(AcStatus.x_ALLOW_DEP18)
        const [def_d_x_ALLOW_WD18, setdef_d_x_ALLOW_WD18] = useState(AcStatus.x_ALLOW_WD18)
    
        const [def_d_x_ALLOW_BUY19, setdef_d_x_ALLOW_BUY19] = useState(AcStatus.x_ALLOW_BUY19)
        const [def_d_x_ALLOW_SELL19, setdef_d_x_ALLOW_SELL19] = useState(AcStatus.x_ALLOW_SELL19)
        const [def_d_x_ALLOW_PYMT19, setdef_d_x_ALLOW_PYMT19] = useState(AcStatus.x_ALLOW_PYMT19)
        const [def_d_x_ALLOW_REC19, setdef_d_x_ALLOW_REC19] = useState(AcStatus.x_ALLOW_REC19)
        const [def_d_x_ALLOW_DEP19, setdef_d_x_ALLOW_DEP19] = useState(AcStatus.x_ALLOW_DEP19)
        const [def_d_x_ALLOW_WD19, setdef_d_x_ALLOW_WD19] = useState(AcStatus.x_ALLOW_WD19)
    
        const [IsNotALLOW20, setIsNotALLOW20] = useState((RESR_Code.indexOf(AcStatus.x_AC_SDESC20) >= 0))
        const [def_d_x_ALLOW_BUY20, setdef_d_x_ALLOW_BUY20] = useState(AcStatus.x_ALLOW_BUY20)
        const [def_d_x_ALLOW_SELL20, setdef_d_x_ALLOW_SELL20] = useState(AcStatus.x_ALLOW_SELL20)
        const [def_d_x_ALLOW_PYMT20, setdef_d_x_ALLOW_PYMT20] = useState(AcStatus.x_ALLOW_PYMT20)
        const [def_d_x_ALLOW_REC20, setdef_d_x_ALLOW_REC20] = useState(AcStatus.x_ALLOW_REC20)
        const [def_d_x_ALLOW_DEP20, setdef_d_x_ALLOW_DEP20] = useState(AcStatus.x_ALLOW_DEP20)
        const [def_d_x_ALLOW_WD20, setdef_d_x_ALLOW_WD20] = useState(AcStatus.x_ALLOW_WD20)
 

        const [IsShowMe1, setIsShowMe1] = useState(false)
        const [IsShowMe2, setIsShowMe2] = useState(false)
        const [IsShowMe3, setIsShowMe3] = useState(false)

        const [IsShowMe4, setIsShowMe4] = useState(false) // useState(!(RESR_Code_noShow.indexOf(AcStatus.d_StatusCode4) == 1))
        const [IsShowMe5, setIsShowMe5] = useState(false)  //useState(!(RESR_Code_noShow.indexOf(AcStatus.d_StatusCode5) == 1))
        const [IsShowMe6, setIsShowMe6] = useState(false)
        const [IsShowMe7, setIsShowMe7] = useState(false)
        const [IsShowMe8, setIsShowMe8] = useState(false)
        const [IsShowMe9, setIsShowMe9] = useState(false)
        const [IsShowMe10, setIsShowMe10] = useState(false)
        const [IsShowMe11, setIsShowMe11] = useState(false)
        const [IsShowMe12, setIsShowMe12] = useState(false)
        const [IsShowMe13, setIsShowMe13] = useState(false)
        const [IsShowMe14, setIsShowMe14] = useState(false)
        const [IsShowMe15, setIsShowMe15] = useState(false)
        const [IsShowMe16, setIsShowMe16] = useState(false)
        const [IsShowMe17, setIsShowMe17] = useState(false)
        const [IsShowMe18, setIsShowMe18] = useState(false)
        const [IsShowMe19, setIsShowMe19] = useState(false)
        const [IsShowMe20, setIsShowMe20] = useState(false)        

        useEffect(() => {
            // Call reset to set default values if ac is passed
            
            
            if ("d_StatusCode1" in AcStatus) {
                reset(AcStatus)
            }
           
        }, [AcStatus, reset])
    

    useEffect(() => {
        // Suggest don't have ref to use with react-hook-form, so register it manually and call setValue when item is selected
        //register({ name: "x_Status" })
    }, [register])

    
    useEffect(() => {
        if ( GsbFlag.Enter2tab == "Y" ) {
            let inputs = utils.PerformEnter2Tab()
        }
    }, [])
    
  
    useEffect(() => {
        (async () => {
            try {
                
                if (AcStatus.d_StatusCode4.trim().length == 0) {
                    setIsShowMe4(false)
                }
                else {
                    setIsShowMe4(true)
                }

                if (AcStatus.d_StatusCode5.trim().length == 0)
                {                    
                    setIsShowMe5(false)
                }
                else
                {
                    setIsShowMe5(true)
                }

                if (AcStatus.d_StatusCode6.trim().length == 0) {
                    setIsShowMe6(false)
                }
                else {
                    setIsShowMe6(true)
                }
      
                if (AcStatus.d_StatusCode7.trim().length == 0) {
                    setIsShowMe7(false)
                }
                else {
                    setIsShowMe7(true)
                }

 
                if (AcStatus.d_StatusCode8.trim().length == 0) {
                    setIsShowMe8(false)
                }
                else {
                    setIsShowMe8(true)
                }

                if (AcStatus.d_StatusCode9.trim().length == 0) {
                    setIsShowMe9(false)
                }
                else {
                    setIsShowMe9(true)
                }
                
      
                
                if (AcStatus.d_StatusCode10.trim().length == 0) {
                    setIsShowMe10(false)
                }
                else {
                    setIsShowMe10(true)
                }
                //d_StatusCode11
                if (AcStatus.d_StatusCode11.trim().length == 0) {
                    setIsShowMe11(false)
                }
                else {
                    setIsShowMe11(true)
                }
                //d_StatusCode12

                if (AcStatus.d_StatusCode12.trim().length == 0) {
                    setIsShowMe12(false)
                }
                else {
                    setIsShowMe12(true)
                }
                //d_StatusCode13
                if (AcStatus.d_StatusCode13.trim().length == 0) {
                    setIsShowMe13(false)
                }
                else {
                    setIsShowMe13(true)
                }               
                //d_StatusCode14
                if (AcStatus.d_StatusCode14.trim().length == 0) {
                    setIsShowMe14(false)
                }
                else {
                    setIsShowMe14(true)
                }
                //d_StatusCode15
                if (AcStatus.d_StatusCode15.trim().length == 0) {
                    setIsShowMe15(false)
                }
                else {
                    setIsShowMe15(true)
                }
                //d_StatusCode16

                if (AcStatus.d_StatusCode16.trim().length == 0) {
                    setIsShowMe16(false)
                }
                else {
                    setIsShowMe16(true)
                }
                //d_StatusCode17
                if (AcStatus.d_StatusCode17.trim().length == 0) {
                    setIsShowMe17(false)
                }
                else {
                    setIsShowMe17(true)
                }
                //d_StatusCode18
                if (AcStatus.d_StatusCode18.trim().length == 0) {
                    setIsShowMe18(false)
                }
                else {
                    setIsShowMe18(true)
                }
                //d_StatusCode19
                if (AcStatus.d_StatusCode19.trim().length == 0) {
                    setIsShowMe19(false)
                }
                else {
                    setIsShowMe19(true)
                }
                //d_StatusCode20
                if (AcStatus.d_StatusCode20.trim().length == 0) {
                    setIsShowMe20(false)
                }
                else {
                    setIsShowMe20(true)
                }                
            } catch (error) {
                utils.showError(error)
            }
        })()
    }, [gsb, AcStatus])
    
    //if (! isNew && !("d_tr_date" in AcStatus)) return null




    const onSubmit = (data: AcStatusInfo) => {
        //console.log("onsubmit called", data)

        // put value to json/field before write database dbf
        //data.d_CE_No = data.d_CE_No.toUpperCase();
       
      
        data.x_ALLOW_BUY1 = def_d_x_ALLOW_BUY1;
        data.x_ALLOW_SELL1 = def_d_x_ALLOW_SELL1;
        
        data.x_ALLOW_PYMT1 = def_d_x_ALLOW_PYMT1
        data.x_ALLOW_REC1 = def_d_x_ALLOW_REC1
        data.x_ALLOW_DEP1 = def_d_x_ALLOW_DEP1
        data.x_ALLOW_WD1 = def_d_x_ALLOW_WD1
 
        data.x_ALLOW_BUY2 = def_d_x_ALLOW_BUY2
        data.x_ALLOW_SELL2 = def_d_x_ALLOW_SELL2
        data.x_ALLOW_PYMT2 = def_d_x_ALLOW_PYMT2
        data.x_ALLOW_REC2 = def_d_x_ALLOW_REC2
        data.x_ALLOW_DEP2 = def_d_x_ALLOW_DEP2
        data.x_ALLOW_WD2 = def_d_x_ALLOW_WD2
 
        data.x_ALLOW_BUY3 = def_d_x_ALLOW_BUY3
        data.x_ALLOW_SELL3 = def_d_x_ALLOW_SELL3
        data.x_ALLOW_PYMT3 = def_d_x_ALLOW_PYMT3
        data.x_ALLOW_REC3 = def_d_x_ALLOW_REC3
        data.x_ALLOW_DEP3 = def_d_x_ALLOW_DEP3
        data.x_ALLOW_WD3 = def_d_x_ALLOW_WD3
  
        data.x_ALLOW_BUY4 = def_d_x_ALLOW_BUY4
        data.x_ALLOW_SELL4 = def_d_x_ALLOW_SELL4
        data.x_ALLOW_PYMT4 = def_d_x_ALLOW_PYMT4
        data.x_ALLOW_REC4 = def_d_x_ALLOW_REC4
        data.x_ALLOW_DEP4 = def_d_x_ALLOW_DEP4
        data.x_ALLOW_WD4 = def_d_x_ALLOW_WD4
  
        data.x_ALLOW_BUY5 = def_d_x_ALLOW_BUY5
        data.x_ALLOW_SELL5 = def_d_x_ALLOW_SELL5
        data.x_ALLOW_PYMT5 = def_d_x_ALLOW_PYMT5
        data.x_ALLOW_REC5 = def_d_x_ALLOW_REC5
        data.x_ALLOW_DEP5 = def_d_x_ALLOW_DEP5
        data.x_ALLOW_WD5 = def_d_x_ALLOW_WD5
  
        data.x_ALLOW_BUY6 = def_d_x_ALLOW_BUY6
        data.x_ALLOW_SELL6 = def_d_x_ALLOW_SELL6
        data.x_ALLOW_PYMT6 = def_d_x_ALLOW_PYMT6
        data.x_ALLOW_REC6 = def_d_x_ALLOW_REC6
        data.x_ALLOW_DEP6 = def_d_x_ALLOW_DEP6
        data.x_ALLOW_WD6 = def_d_x_ALLOW_WD6
 
        data.x_ALLOW_BUY7 = def_d_x_ALLOW_BUY7
        data.x_ALLOW_SELL7 = def_d_x_ALLOW_SELL7
        data.x_ALLOW_PYMT7 = def_d_x_ALLOW_PYMT7
        data.x_ALLOW_REC7 = def_d_x_ALLOW_REC7
        data.x_ALLOW_DEP7 = def_d_x_ALLOW_DEP7
        data.x_ALLOW_WD7 = def_d_x_ALLOW_WD7
  
        data.x_ALLOW_BUY8 = def_d_x_ALLOW_BUY8
        data.x_ALLOW_SELL8 = def_d_x_ALLOW_SELL8
        data.x_ALLOW_PYMT8 = def_d_x_ALLOW_PYMT8
        data.x_ALLOW_REC8 = def_d_x_ALLOW_REC8
        data.x_ALLOW_DEP8 = def_d_x_ALLOW_DEP8
        data.x_ALLOW_WD8 = def_d_x_ALLOW_WD8
 
        data.x_ALLOW_BUY9 = def_d_x_ALLOW_BUY9
        data.x_ALLOW_SELL9 = def_d_x_ALLOW_SELL9
        data.x_ALLOW_PYMT9 = def_d_x_ALLOW_PYMT9
        data.x_ALLOW_REC9 = def_d_x_ALLOW_REC9
        data.x_ALLOW_DEP9 = def_d_x_ALLOW_DEP9
        data.x_ALLOW_WD9 = def_d_x_ALLOW_WD9
 
        data.x_ALLOW_BUY10 = def_d_x_ALLOW_BUY10
        data.x_ALLOW_SELL10 = def_d_x_ALLOW_SELL10
        data.x_ALLOW_PYMT10 = def_d_x_ALLOW_PYMT10
        data.x_ALLOW_REC10 = def_d_x_ALLOW_REC10
        data.x_ALLOW_DEP10 = def_d_x_ALLOW_DEP10
        data.x_ALLOW_WD10 = def_d_x_ALLOW_WD10
      
        data.x_ALLOW_BUY11 = def_d_x_ALLOW_BUY11
        data.x_ALLOW_SELL11 = def_d_x_ALLOW_SELL11
        data.x_ALLOW_PYMT11 = def_d_x_ALLOW_PYMT11
        data.x_ALLOW_REC11 = def_d_x_ALLOW_REC11
        data.x_ALLOW_DEP11 = def_d_x_ALLOW_DEP11
        data.x_ALLOW_WD11 = def_d_x_ALLOW_WD11
   
        data.x_ALLOW_BUY12 = def_d_x_ALLOW_BUY12
        data.x_ALLOW_SELL12 = def_d_x_ALLOW_SELL12
        data.x_ALLOW_PYMT12 = def_d_x_ALLOW_PYMT12
        data.x_ALLOW_REC12 = def_d_x_ALLOW_REC12
        data.x_ALLOW_DEP12 = def_d_x_ALLOW_DEP12
        data.x_ALLOW_WD12 = def_d_x_ALLOW_WD12

        data.x_ALLOW_BUY13 = def_d_x_ALLOW_BUY13
        data.x_ALLOW_SELL13 = def_d_x_ALLOW_SELL13
        data.x_ALLOW_PYMT13 = def_d_x_ALLOW_PYMT13
        data.x_ALLOW_REC13 = def_d_x_ALLOW_REC13
        data.x_ALLOW_DEP13 = def_d_x_ALLOW_DEP13
        data.x_ALLOW_WD13 = def_d_x_ALLOW_WD13
   
        data.x_ALLOW_BUY14 = def_d_x_ALLOW_BUY14
        data.x_ALLOW_SELL14 = def_d_x_ALLOW_SELL14
        data.x_ALLOW_PYMT14 = def_d_x_ALLOW_PYMT14
        data.x_ALLOW_REC14 = def_d_x_ALLOW_REC14
        data.x_ALLOW_DEP14 = def_d_x_ALLOW_DEP14
        data.x_ALLOW_WD14 = def_d_x_ALLOW_WD14
 
        data.x_ALLOW_BUY15 = def_d_x_ALLOW_BUY15;
        data.x_ALLOW_SELL15 = def_d_x_ALLOW_SELL15;
        data.x_ALLOW_PYMT15 = def_d_x_ALLOW_PYMT15;
        data.x_ALLOW_REC15 = def_d_x_ALLOW_REC15;
        data.x_ALLOW_DEP15 = def_d_x_ALLOW_DEP15;
        data.x_ALLOW_WD15 = def_d_x_ALLOW_WD15;
    
        data.x_ALLOW_BUY16 = def_d_x_ALLOW_BUY16;
        data.x_ALLOW_SELL16 = def_d_x_ALLOW_SELL16;
        data.x_ALLOW_PYMT16 = def_d_x_ALLOW_PYMT16;
        data.x_ALLOW_REC16 = def_d_x_ALLOW_REC16;
        data.x_ALLOW_DEP16 = def_d_x_ALLOW_DEP16;
        data.x_ALLOW_WD16 = def_d_x_ALLOW_WD16;
  
        data.x_ALLOW_BUY17 = def_d_x_ALLOW_BUY17;
        data.x_ALLOW_SELL17 = def_d_x_ALLOW_SELL17;
        data.x_ALLOW_PYMT17 = def_d_x_ALLOW_PYMT17;
        data.x_ALLOW_REC17 = def_d_x_ALLOW_REC17;
        data.x_ALLOW_DEP17 = def_d_x_ALLOW_DEP17;
        data.x_ALLOW_WD17 = def_d_x_ALLOW_WD17;

        data.x_ALLOW_BUY18 = def_d_x_ALLOW_BUY18;
        data.x_ALLOW_SELL18 = def_d_x_ALLOW_SELL18;
        data.x_ALLOW_PYMT18 = def_d_x_ALLOW_PYMT18;
        data.x_ALLOW_REC18 = def_d_x_ALLOW_REC18;
        data.x_ALLOW_DEP18 = def_d_x_ALLOW_DEP18;
        data.x_ALLOW_WD18 = def_d_x_ALLOW_WD18;

        data.x_ALLOW_BUY19 = def_d_x_ALLOW_BUY19;
        data.x_ALLOW_SELL19 = def_d_x_ALLOW_SELL19;
        data.x_ALLOW_PYMT19 = def_d_x_ALLOW_PYMT19;
        data.x_ALLOW_REC19 = def_d_x_ALLOW_REC19;
        data.x_ALLOW_DEP19 = def_d_x_ALLOW_DEP19;
        data.x_ALLOW_WD19 = def_d_x_ALLOW_WD19;

        data.x_ALLOW_BUY20 = def_d_x_ALLOW_BUY20;
        data.x_ALLOW_SELL20 = def_d_x_ALLOW_SELL20;
        data.x_ALLOW_PYMT20 = def_d_x_ALLOW_PYMT20;
        data.x_ALLOW_REC20 = def_d_x_ALLOW_REC20;
        data.x_ALLOW_DEP20 = def_d_x_ALLOW_DEP20;
        data.x_ALLOW_WD20 = def_d_x_ALLOW_WD20; 

 
        (async () => {
            try {
               // console.log("call AcStatusedit data", data)
               // console.log("call AcStatusedit isNew", isNew)
                const res = await gsb.post('/Master', {sb_data: data, cPgmId: "AcStatus", cAction: "AcStatusValidate", isNew: isNew})
              //  console.log("AcStatusedit res.data.ok", res.data.ok)
               // console.log("AcStatusedit res.data.data", res.data.data)

                if (! res.data.ok) {
                    for (let j = 0; j < res.data.data.length; j++) {
                      
                        setError(res.data.data[j][0], {
                           message: res.data.data[j][1]
                        }); 
                    }
                    return
                }

                onSave(data)

            } catch (error) {
                showErrorBox(error)
            }
        })()
    }



    function highlightText(text: string, query: string) {
        let lastIndex = 0;
        const words = query
            .split(/\s+/)
            .filter(word => word.length > 0)
            .map(escapeRegExpChars);
        if (words.length === 0) {
            return [text];
        }
        const regexp = new RegExp(words.join("|"), "gi");
        const tokens: React.ReactNode[] = [];
        while (true) {
            const match = regexp.exec(text);
            if (!match) {
                break;
            }
            const length = match[0].length;
            const before = text.slice(lastIndex, regexp.lastIndex - length);
            if (before.length > 0) {
                tokens.push(before);
            }
            lastIndex = regexp.lastIndex;
            tokens.push(<strong key={lastIndex}>{match[0]}</strong>);
        }
        const rest = text.slice(lastIndex);
        if (rest.length > 0) {
            tokens.push(rest);
        }
        return tokens;
    }

    function escapeRegExpChars(text: string) {
        //return text.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1");
        return text.replace(/([.*+?^=!:${}()|\\])/g, "\\$1");
    }

    const handleHotkey = (e: React.KeyboardEvent<HTMLFormElement>) => {
        //console.log(`ctrl:${e.ctrlKey} alt:${e.altKey} shift:${e.shiftKey} meta:${e.metaKey} key:${e.key} keyCode:${e.keyCode}`)

        // ctrl + s
        if (e.ctrlKey && e.keyCode === 83) {
            e.preventDefault()
            //handleSubmit(onSubmit)()
        }
    }

    const showErrorBox = (err: any) => {
        alert("Error:"+err.response.data.subSystem+" - "+err.response.data.description+", OS code:"+err.response.data.osCode)
    }


    useEffect(() => {
        (async () => {
            try {
                // get GsbFlag from SB.XBS
              
              
            } catch (error) {
                utils.showError(error)
            }
        })()
    }, [gsb])

 
    // 假設你有 20 個輸入框，預設全部禁用 (true)
    const [isDisableAllows, setIsDisableAllows] = useState<boolean[]>(new Array(20).fill(true));


    const handleMultipleInputChange = (index: number) => (event: React.FormEvent<HTMLInputElement>) => {
    const value = event.currentTarget.value;
    
    // 判斷是否為空或空格
    const isDisabled = value.trim() === "";

    setIsDisableAllows(prev => {
        const newState = [...prev]; // 保持不可變性
        newState[index] = isDisabled;
        return newState;
    });
};

 
 

    const handleInputChange4 = (event: React.FormEvent<HTMLInputElement>) => {
        //console.log(event.currentTarget.name)
        if (event.currentTarget.value === " " || event.currentTarget.value === "") {   
            setIsShowMe4(false)
        }
        else {
            setIsShowMe4(true)
        }

        //setInputValue1(event.currentTarget.value);
    };

    const handleInputChange5 = (event: React.FormEvent<HTMLInputElement>) => {        
        if (event.currentTarget.value === " " || event.currentTarget.value === "" ) {        
           // setIsNotALLOW5(false)
            setIsShowMe5(false)
        }
        else {       
            setIsShowMe5(true)
        }
    };

    const handleInputChange6 = (event: React.FormEvent<HTMLInputElement>) => {
        if (event.currentTarget.value === " " || event.currentTarget.value === "" ) {
            // setIsNotALLOW5(false)
            setIsShowMe6(false)
        }
        else {
            setIsShowMe6(true)
        }
    };


    const handleInputChange7 = (event: React.FormEvent<HTMLInputElement>) => {
        if (event.currentTarget.value === " " || event.currentTarget.value === "") {
            // setIsNotALLOW5(false)
            setIsShowMe7(false)
        }
        else {
            setIsShowMe7(true)
        }
    };


    const handleInputChange8 = (event: React.FormEvent<HTMLInputElement>) => {
        if (event.currentTarget.value === " " || event.currentTarget.value === "") {
            setIsShowMe8(false)
        }
        else {
            setIsShowMe8(true)
        }
    };

    const handleInputChange9 = (event: React.FormEvent<HTMLInputElement>) => {
        if (event.currentTarget.value === " " || event.currentTarget.value === "") {
            setIsShowMe9(false)
        }
        else {
            setIsShowMe9(true)
        }
    };


    const handleInputChange10 = (event: React.FormEvent<HTMLInputElement>) => {
        if (event.currentTarget.value === " " || event.currentTarget.value === "") {
            setIsShowMe10(false)
        }
        else {
            setIsShowMe10(true)
        }
    };


    const handleInputChange11 = (event: React.FormEvent<HTMLInputElement>) => {
        if (event.currentTarget.value === " " || event.currentTarget.value === "") {
            setIsShowMe11(false)
        }
        else {
            setIsShowMe11(true)
        }
    };

    const handleInputChange12 = (event: React.FormEvent<HTMLInputElement>) => {
        if (event.currentTarget.value === " " || event.currentTarget.value === "") {
            setIsShowMe12(false)
        }
        else {
            setIsShowMe12(true)
        }
    };

    const handleInputChange13 = (event: React.FormEvent<HTMLInputElement>) => {
        if (event.currentTarget.value === " " || event.currentTarget.value === "") {
            setIsShowMe13(false)
        }
        else {
            setIsShowMe13(true)
        }
    };

    const handleInputChange14 = (event: React.FormEvent<HTMLInputElement>) => {
        if (event.currentTarget.value === " " || event.currentTarget.value === "") {
            setIsShowMe14(false)
        }
        else {
            setIsShowMe14(true)
        }
    };

    const handleInputChange15 = (event: React.FormEvent<HTMLInputElement>) => {
        if (event.currentTarget.value === " " || event.currentTarget.value === "") {
            setIsShowMe15(false)
        }
        else {
            setIsShowMe15(true)
        }
    };

    const handleInputChange16 = (event: React.FormEvent<HTMLInputElement>) => {
        if (event.currentTarget.value === " " || event.currentTarget.value === "") {
            setIsShowMe16(false)
        }
        else {
            setIsShowMe16(true)
        }
    };


    const handleInputChange17 = (event: React.FormEvent<HTMLInputElement>) => {
        if (event.currentTarget.value === " " || event.currentTarget.value === "") {
            setIsShowMe17(false)
        }
        else {
            setIsShowMe17(true)
        }
    };


    const handleInputChange18 = (event: React.FormEvent<HTMLInputElement>) => {
        if (event.currentTarget.value === " " || event.currentTarget.value === "") {
            setIsShowMe18(false)
        }
        else {
            setIsShowMe18(true)
        }
    };

    const handleInputChange19 = (event: React.FormEvent<HTMLInputElement>) => {
        if (event.currentTarget.value === " " || event.currentTarget.value === "") {
            setIsShowMe19(false)
        }
        else {
            setIsShowMe19(true)
        }
    };

    const handleInputChange20 = (event: React.FormEvent<HTMLInputElement>) => {
        if (event.currentTarget.value === " " || event.currentTarget.value === "") {
            setIsShowMe20(false)
        }
        else {
            setIsShowMe20(true)
        }
    };
 
    
    /*<form onSubmit={handleSubmit(onSubmit)}>*/
    return (
        <form onKeyDown={handleHotkey}>

            <div className="Row">
                <Button className="Col-1-1" icon="cross" onClick={() => onCancel()}>Cancel</Button>
                <Button className="Col-2-1" icon="tick" onClick={handleSubmit(onSubmit)}>Save</Button>
            </div>
            <div className="Spacing-V-16" />


       

            <div className="Row">
                <FormGroup className="Col-1-1" label="Code">
                    <InputGroup id="inputStatusCode" disabled={( RESR_Code.indexOf(AcStatus.d_StatusCode1) >= 0 )} name="d_StatusCode1" defaultValue={AcStatus.d_StatusCode1}  placeholder="Status Code ..." inputRef={register({ maxLength: 1}) } />
                    {errors.d_StatusCode1 && errors.d_StatusCode1.type === "maxLength" && <span id="Err_msg">Max length is 1</span>}
                    {errors.d_StatusCode1 && errors.d_StatusCode1.types && <span id="Err_msg">{errors.d_StatusCode1.types.message}</span>}
                </FormGroup>
                <FormGroup className="Col-2-2" label="Account Status">
                    <InputGroup id="inputStatusDesc" name="x_AC_SDESC1" defaultValue={AcStatus.x_AC_SDESC1} placeholder="Account Status ..."    inputRef={register({ maxLength: 15}) } />
                    {errors.x_AC_SDESC1 && errors.x_AC_SDESC1.type === "maxLength" && <span id="Err_msg">Max length is 15</span>}
                    {errors.x_AC_SDESC1 && errors.x_AC_SDESC1.types && <span id="Err_msg">{errors.x_AC_SDESC1.types.message}</span>}
                </FormGroup>
                
                <FormGroup className="Col-4-1" label="Allow Buy" >
                    <RadioGroup
                        name="d_x_ALLOW_BUY1"
                        inline={true}
                        
                        selectedValue={def_d_x_ALLOW_BUY1}
                        onChange={utils.handleStringChange(s => setdef_d_x_ALLOW_BUY1(s))}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup> 
                <FormGroup className="Col-5-1" label="Allow Sell"  >
                    <RadioGroup
                        name="d_x_ALLOW_SELL1"
                        inline={true}
                                            
                        selectedValue={def_d_x_ALLOW_SELL1}
                        onChange={utils.handleStringChange(s => setdef_d_x_ALLOW_SELL1(s))}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>      

                <FormGroup className="Col-6-1" label="Allow Payment"  >
                    <RadioGroup
                        name="d_x_ALLOW_PYMT1"
                        inline={true}
                                    
                        selectedValue={def_d_x_ALLOW_PYMT1}
                        onChange={utils.handleStringChange(s => setdef_d_x_ALLOW_PYMT1(s))}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup> 

                <FormGroup className="Col-7-1" label="Allow Recevie"  >
                    <RadioGroup
                        name="d_x_ALLOW_REC1"
                        inline={true}
                                         
                        selectedValue={def_d_x_ALLOW_REC1}
                        onChange={utils.handleStringChange(s => setdef_d_x_ALLOW_REC1(s))}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>        

                <FormGroup className="Col-8-1" label="Allow Desposit"  >
                    <RadioGroup
                        name="d_x_ALLOW_DEP1"
                        inline={true}
                                     
                        selectedValue={def_d_x_ALLOW_DEP1}
                        onChange={utils.handleStringChange(s => setdef_d_x_ALLOW_DEP1(s))}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>

                <FormGroup className="Col-9-1" label="Allow Withdrawal"  >
                    <RadioGroup
                        name="d_x_ALLOW_WD1"
                        inline={true}
                                       
                        selectedValue={def_d_x_ALLOW_WD1}
                        onChange={utils.handleStringChange(s => setdef_d_x_ALLOW_WD1(s))}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>



            </div>
            <div className="Row">
                <FormGroup className="Col-1-1" label="">
                    <InputGroup id="inputStatusCode" disabled={( RESR_Code.indexOf(AcStatus.d_StatusCode2) >= 0 )} name="d_StatusCode2" defaultValue={AcStatus.d_StatusCode2} placeholder="Status Code ..." inputRef={register({ maxLength: 1}) } />
                    {errors.d_StatusCode2 && errors.d_StatusCode2.type === "maxLength" && <span id="Err_msg">Max length is 1</span>}
                    {errors.d_StatusCode2 && errors.d_StatusCode2.types && <span id="Err_msg">{errors.d_StatusCode2.types.message}</span>}
                </FormGroup>
                <FormGroup className="Col-2-2" label="">
                    <InputGroup id="inputStatusDesc" name="x_AC_SDESC2" defaultValue={AcStatus.x_AC_SDESC2} placeholder="Account Status ..."    inputRef={register({ maxLength: 15}) } />
                    {errors.x_AC_SDESC2 && errors.x_AC_SDESC2.type === "maxLength" && <span id="Err_msg">Max length is 15</span>}
                    {errors.x_AC_SDESC2 && errors.x_AC_SDESC2.types && <span id="Err_msg">{errors.x_AC_SDESC2.types.message}</span>}
                </FormGroup>
                <FormGroup className="Col-4-1"   >
                    <RadioGroup
                        name="d_x_ALLOW_BUY2"
                        inline={true}                         
                        selectedValue={def_d_x_ALLOW_BUY2}
                        onChange={utils.handleStringChange(s => setdef_d_x_ALLOW_BUY2(s))}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>
                <FormGroup className="Col-5-1"    >
                    <RadioGroup
                        name="d_x_ALLOW_SELL2"
                        inline={true}                          
                        selectedValue={def_d_x_ALLOW_SELL2}
                        onChange={utils.handleStringChange(s => setdef_d_x_ALLOW_SELL2(s))}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>

                <FormGroup className="Col-6-1"   >
                    <RadioGroup
                        name="d_x_ALLOW_PYMT2"
                        inline={true}    
                        selectedValue={def_d_x_ALLOW_PYMT2}
                        onChange={utils.handleStringChange(s => setdef_d_x_ALLOW_PYMT2(s))}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>

                <FormGroup className="Col-7-1"  >
                    <RadioGroup
                        name="d_x_ALLOW_REC2"
                        inline={true}
                        selectedValue={def_d_x_ALLOW_REC2}
                        onChange={utils.handleStringChange(s => setdef_d_x_ALLOW_REC2(s))}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>

                <FormGroup className="Col-8-1"   >
                    <RadioGroup
                        name="d_x_ALLOW_DEP2"
                        inline={true}
                        selectedValue={def_d_x_ALLOW_DEP2}
                        onChange={utils.handleStringChange(s => setdef_d_x_ALLOW_DEP2(s))}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>

                <FormGroup className="Col-9-1"    >
                    <RadioGroup
                        name="d_x_ALLOW_WD2"
                        inline={true}
                        selectedValue={def_d_x_ALLOW_WD2}
                        onChange={utils.handleStringChange(s => setdef_d_x_ALLOW_WD2(s))}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>

            </div>
            <div className="Row">
                <FormGroup className="Col-1-1" label="">
                    <InputGroup id="inputStatusCode" disabled={( RESR_Code.indexOf(AcStatus.d_StatusCode3) >= 0 )} name="d_StatusCode3" defaultValue={AcStatus.d_StatusCode3} placeholder="Status Code ..." inputRef={register({ maxLength: 1}) } />
                    {errors.d_StatusCode3 && errors.d_StatusCode3.type === "maxLength" && <span id="Err_msg">Max length is 1</span>}
                    {errors.d_StatusCode3 && errors.d_StatusCode3.types && <span id="Err_msg">{errors.d_StatusCode3.types.message}</span>}
                </FormGroup>
                <FormGroup className="Col-2-2" label="">
                    <InputGroup id="inputStatusDesc" name="x_AC_SDESC3" defaultValue={AcStatus.x_AC_SDESC3} placeholder="Account Status ..."    inputRef={register({ maxLength: 15}) } />
                    {errors.x_AC_SDESC3 && errors.x_AC_SDESC3.type === "maxLength" && <span id="Err_msg">Max length is 15</span>}
                    {errors.x_AC_SDESC3 && errors.x_AC_SDESC3.types && <span id="Err_msg">{errors.x_AC_SDESC3.types.message}</span>}
                </FormGroup>
                <FormGroup className="Col-4-1"   >
                    <RadioGroup
                        name="d_x_ALLOW_BUY3"
                        inline={true}
                        selectedValue={def_d_x_ALLOW_BUY3}
                        onChange={utils.handleStringChange(s => setdef_d_x_ALLOW_BUY3(s))}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>
                <FormGroup className="Col-5-1"    >
                    <RadioGroup
                        name="d_x_ALLOW_SELL3"
                        inline={true}
                        selectedValue={def_d_x_ALLOW_SELL3}
                        onChange={utils.handleStringChange(s => setdef_d_x_ALLOW_SELL3(s))}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>

                <FormGroup className="Col-6-1"   >
                    <RadioGroup
                        name="d_x_ALLOW_PYMT3"
                        inline={true}
                        selectedValue={def_d_x_ALLOW_PYMT3}
                        onChange={utils.handleStringChange(s => setdef_d_x_ALLOW_PYMT3(s))}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>

                <FormGroup className="Col-7-1"  >
                    <RadioGroup
                        name="d_x_ALLOW_REC3"
                        inline={true}
                        selectedValue={def_d_x_ALLOW_REC3}
                        onChange={utils.handleStringChange(s => setdef_d_x_ALLOW_REC3(s))}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>

                <FormGroup className="Col-8-1"   >
                    <RadioGroup
                        name="d_x_ALLOW_DEP3"
                        inline={true}                        
                        selectedValue={def_d_x_ALLOW_DEP3}
                        onChange={utils.handleStringChange(s => setdef_d_x_ALLOW_DEP3(s))}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>

                <FormGroup className="Col-9-1"    >
                    <RadioGroup
                        name="d_x_ALLOW_WD3"
                        inline={true}                     
                        selectedValue={def_d_x_ALLOW_WD3}
                        onChange={utils.handleStringChange(s => setdef_d_x_ALLOW_WD3(s))}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>                  
            </div>
            <div className="Row">
                <FormGroup className="Col-1-1" label="">
                    <InputGroup id="inputStatusCode" disabled={(RESR_Code.indexOf(AcStatus.d_StatusCode4) >= 0)} name="d_StatusCode4" defaultValue={AcStatus.d_StatusCode4} placeholder="Status Code ..."
                    onChange={handleInputChange4} inputRef={register({ maxLength: 1}) } />
                    {errors.d_StatusCode4 && errors.d_StatusCode4.type === "maxLength" && <span id="Err_msg">Max length is 1</span>}
                    {errors.d_StatusCode4 && errors.d_StatusCode4.types && <span id="Err_msg">{errors.d_StatusCode4.types.message}</span>}
                </FormGroup>
                <FormGroup className="Col-2-2" label="">
                    <InputGroup id="inputStatusDesc" name="x_AC_SDESC4" defaultValue={AcStatus.x_AC_SDESC4} placeholder="Account Status ..."   inputRef={register({ maxLength: 15}) } />
                    {errors.x_AC_SDESC4 && errors.x_AC_SDESC4.type === "maxLength" && <span id="Err_msg">Max length is 15</span>}
                    {errors.x_AC_SDESC4 && errors.x_AC_SDESC4.types && <span id="Err_msg">{errors.x_AC_SDESC4.types.message}</span>}
                </FormGroup>
                {IsShowMe4 && <FormGroup className="Col-4-1"   >
                    <RadioGroup
                        name="d_x_ALLOW_BUY4"
                        inline={true}                     
                        selectedValue={def_d_x_ALLOW_BUY4}
                        onChange={utils.handleStringChange(s => setdef_d_x_ALLOW_BUY4(s))}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}
                {IsShowMe4 &&<FormGroup className="Col-5-1"    >
                    <RadioGroup
                        name="d_x_ALLOW_SELL4"
                        inline={true}                       
                        selectedValue={def_d_x_ALLOW_SELL4}
                        onChange={utils.handleStringChange(s => setdef_d_x_ALLOW_SELL4(s))}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}

                {IsShowMe4 && <FormGroup className="Col-6-1"   >
                    <RadioGroup
                        name="d_x_ALLOW_PYMT4"
                        inline={true}                       
                        selectedValue={def_d_x_ALLOW_PYMT4}
                        onChange={utils.handleStringChange(s => setdef_d_x_ALLOW_PYMT4(s))}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}
                {IsShowMe4 && <FormGroup className="Col-7-1"  >
                    <RadioGroup
                        name="d_x_ALLOW_REC4"
                        inline={true}                    
                        selectedValue={def_d_x_ALLOW_REC4}
                        onChange={utils.handleStringChange(s => setdef_d_x_ALLOW_REC4(s))}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}

                {IsShowMe4 && <FormGroup className="Col-8-1"   >
                    <RadioGroup
                        name="d_x_ALLOW_DEP4"
                        inline={true}                       
                        selectedValue={def_d_x_ALLOW_DEP4}
                        onChange={utils.handleStringChange(s => setdef_d_x_ALLOW_DEP4(s))}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}

                {IsShowMe4 && <FormGroup className="Col-9-1"    >
                    <RadioGroup
                        name="d_x_ALLOW_WD4"
                        inline={true}
                        selectedValue={def_d_x_ALLOW_WD4}
                        onChange={utils.handleStringChange(s => setdef_d_x_ALLOW_WD4(s))}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}                  
            </div>
            <div className="Row">
                <FormGroup className="Col-1-1" label="">
                    <InputGroup id="inputStatusCode" name="d_StatusCode5" defaultValue={AcStatus.d_StatusCode5} placeholder="Status Code ..." onChange={handleInputChange5} inputRef={register({ maxLength: 1}) } />
                    {errors.d_StatusCode5 && errors.d_StatusCode5.type === "maxLength" && <span id="Err_msg">Max length is 1</span>}
                    {errors.d_StatusCode5 && errors.d_StatusCode5.types && <span id="Err_msg">{errors.d_StatusCode5.types.message}</span>}
                </FormGroup>
                <FormGroup className="Col-2-2" label="">
                    <InputGroup id="inputStatusDesc" name="x_AC_SDESC5" defaultValue={AcStatus.x_AC_SDESC5} placeholder="Account Status ..." inputRef={register({ maxLength: 15}) } />
                    {errors.x_AC_SDESC5 && errors.x_AC_SDESC5.type === "maxLength" && <span id="Err_msg">Max length is 15</span>}
                    {errors.x_AC_SDESC5 && errors.x_AC_SDESC5.types && <span id="Err_msg">{errors.x_AC_SDESC5.types.message}</span>}
                </FormGroup>
                {IsShowMe5 && <FormGroup className="Col-4-1"   >
                    <RadioGroup
                        name="d_x_ALLOW_BUY5"
                        inline={true}
                        selectedValue={def_d_x_ALLOW_BUY5}
                        onChange={utils.handleStringChange(s => setdef_d_x_ALLOW_BUY5(s))}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}
                {IsShowMe5 && <FormGroup className="Col-5-1"    >
                    <RadioGroup
                        name="d_x_ALLOW_SELL5"
                        inline={true}
                        selectedValue={def_d_x_ALLOW_SELL5}
                        onChange={utils.handleStringChange(s => setdef_d_x_ALLOW_SELL5(s))}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}

                {IsShowMe5 && <FormGroup className="Col-6-1"   >
                    <RadioGroup
                        name="d_x_ALLOW_PYMT5"
                        inline={true}

                        selectedValue={def_d_x_ALLOW_PYMT5}
                        onChange={utils.handleStringChange(s => setdef_d_x_ALLOW_PYMT5(s))}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}

                {IsShowMe5 && <FormGroup className="Col-7-1"  >
                    <RadioGroup
                        name="d_x_ALLOW_REC5"
                        inline={true}

                        selectedValue={def_d_x_ALLOW_REC5}
                        onChange={utils.handleStringChange(s => setdef_d_x_ALLOW_REC5(s))}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}

                {IsShowMe5 && <FormGroup className="Col-8-1"   >
                    <RadioGroup
                        name="d_x_ALLOW_DEP5"
                        inline={true}

                        selectedValue={def_d_x_ALLOW_DEP5}
                        onChange={utils.handleStringChange(s => setdef_d_x_ALLOW_DEP5(s))}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}

                {IsShowMe5 && <FormGroup className="Col-9-1"    >
                    <RadioGroup
                        name="d_x_ALLOW_WD5"
                        inline={true}

                        selectedValue={def_d_x_ALLOW_WD5}
                        onChange={utils.handleStringChange(s => setdef_d_x_ALLOW_WD5(s))}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}  
            </div>
            <div className="Row">
                <FormGroup className="Col-1-1" label="">
                    <InputGroup id="inputStatusCode" disabled={(RESR_Code.indexOf(AcStatus.d_StatusCode6) >= 0)} name="d_StatusCode6" defaultValue={AcStatus.d_StatusCode6} onChange={handleInputChange6}  placeholder="Status Code ..." inputRef={register({ maxLength: 1}) } />
                    {errors.d_StatusCode6 && errors.d_StatusCode6.type === "maxLength" && <span id="Err_msg">Max length is 1</span>}
                    {errors.d_StatusCode6 && errors.d_StatusCode6.types && <span id="Err_msg">{errors.d_StatusCode6.types.message}</span>}
                </FormGroup>
                <FormGroup className="Col-2-2" label="">
                    <InputGroup id="inputStatusDesc" name="x_AC_SDESC6" defaultValue={AcStatus.x_AC_SDESC6} placeholder="Account Status ..." inputRef={register({ maxLength: 15}) } />
                    {errors.x_AC_SDESC6 && errors.x_AC_SDESC6.type === "maxLength" && <span id="Err_msg">Max length is 15</span>}
                    {errors.x_AC_SDESC6 && errors.x_AC_SDESC6.types && <span id="Err_msg">{errors.x_AC_SDESC6.types.message}</span>}
                </FormGroup>
                {IsShowMe6 && <FormGroup className="Col-4-1"   >
                    <RadioGroup
                        name="d_x_ALLOW_BUY6"
                        inline={true}

                        selectedValue={def_d_x_ALLOW_BUY6}
                        onChange={utils.handleStringChange(s => setdef_d_x_ALLOW_BUY6(s))}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}
                {IsShowMe6 && <FormGroup className="Col-5-1"    >
                    <RadioGroup
                        name="d_x_ALLOW_SELL6"
                        inline={true}

                        selectedValue={def_d_x_ALLOW_SELL6}
                        onChange={utils.handleStringChange(s => setdef_d_x_ALLOW_SELL6(s))}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}

                {IsShowMe6 && <FormGroup className="Col-6-1"   >
                    <RadioGroup
                        name="d_x_ALLOW_PYMT6"
                        inline={true}

                        selectedValue={def_d_x_ALLOW_PYMT6}
                        onChange={utils.handleStringChange(s => setdef_d_x_ALLOW_PYMT6(s))}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}

                {IsShowMe6 && <FormGroup className="Col-7-1"  >
                    <RadioGroup
                        name="d_x_ALLOW_REC6"
                        inline={true}

                        selectedValue={def_d_x_ALLOW_REC6}
                        onChange={utils.handleStringChange(s => setdef_d_x_ALLOW_REC6(s))}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}

                {IsShowMe6 && <FormGroup className="Col-8-1"   >
                    <RadioGroup
                        name="d_x_ALLOW_DEP6"
                        inline={true}

                        selectedValue={def_d_x_ALLOW_DEP6}
                        onChange={utils.handleStringChange(s => setdef_d_x_ALLOW_DEP6(s))}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}

                {IsShowMe6 && <FormGroup className="Col-9-1"    >
                    <RadioGroup
                        name="d_x_ALLOW_WD6"
                        inline={true}

                        selectedValue={def_d_x_ALLOW_WD6}
                        onChange={utils.handleStringChange(s => setdef_d_x_ALLOW_WD6(s))}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}
            </div>
            <div className="Row">
                <FormGroup className="Col-1-1" label="">
                    <InputGroup id="inputStatusCode" disabled={( RESR_Code.indexOf(AcStatus.d_StatusCode7) >= 0 )} name="d_StatusCode7" defaultValue={AcStatus.d_StatusCode7} 
                    onChange={handleInputChange7} placeholder="Status Code ..." inputRef={register({ maxLength: 1}) } />
                    {errors.d_StatusCode7 && errors.d_StatusCode7.type === "maxLength" && <span id="Err_msg">Max length is 1</span>}
                    {errors.d_StatusCode7 && errors.d_StatusCode7.types && <span id="Err_msg">{errors.d_StatusCode7.types.message}</span>}
                </FormGroup>
                <FormGroup className="Col-2-2" label="">
                    <InputGroup id="inputStatusDesc" name="x_AC_SDESC7" defaultValue={AcStatus.x_AC_SDESC7} placeholder="Account Status ..." inputRef={register({ maxLength: 15}) } />
                    {errors.x_AC_SDESC7 && errors.x_AC_SDESC7.type === "maxLength" && <span id="Err_msg">Max length is 15</span>}
                    {errors.x_AC_SDESC7 && errors.x_AC_SDESC7.types && <span id="Err_msg">{errors.x_AC_SDESC7.types.message}</span>}
                </FormGroup>
                {IsShowMe7 && <FormGroup className="Col-4-1"   >
                    <RadioGroup
                        name="d_x_ALLOW_BUY7"
                        inline={true}
                        selectedValue={def_d_x_ALLOW_BUY7}
                        onChange={utils.handleStringChange(s => setdef_d_x_ALLOW_BUY7(s))}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}
                {IsShowMe7 && <FormGroup className="Col-5-1"    >
                    <RadioGroup
                        name="d_x_ALLOW_SELL7"
                        inline={true}
                        selectedValue={def_d_x_ALLOW_SELL7}
                        onChange={utils.handleStringChange(s => setdef_d_x_ALLOW_SELL7(s))}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}

                {IsShowMe7 && <FormGroup className="Col-6-1"   >
                    <RadioGroup
                        name="d_x_ALLOW_PYMT7"
                        inline={true}
                        selectedValue={def_d_x_ALLOW_PYMT7}
                        onChange={utils.handleStringChange(s => setdef_d_x_ALLOW_PYMT7(s))}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}

                {IsShowMe7 && <FormGroup className="Col-7-1"  >
                    <RadioGroup
                        name="d_x_ALLOW_REC7"
                        inline={true}
                        selectedValue={def_d_x_ALLOW_REC7}
                        onChange={utils.handleStringChange(s => setdef_d_x_ALLOW_REC7(s))}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}

                {IsShowMe7 &&  <FormGroup className="Col-8-1"   >
                    <RadioGroup
                        name="d_x_ALLOW_DEP7"
                        inline={true}
                        selectedValue={def_d_x_ALLOW_DEP7}
                        onChange={utils.handleStringChange(s => setdef_d_x_ALLOW_DEP7(s))}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}

                {IsShowMe7 && <FormGroup className="Col-9-1"    >
                    <RadioGroup
                        name="d_x_ALLOW_WD7"
                        inline={true}
                        selectedValue={def_d_x_ALLOW_WD7}
                        onChange={utils.handleStringChange(s => setdef_d_x_ALLOW_WD7(s))}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}                  
            </div>
            <div className="Row">
                <FormGroup className="Col-1-1" label="">
                    <InputGroup id="inputStatusCode" disabled={( RESR_Code.indexOf(AcStatus.d_StatusCode8) >= 0 )} name="d_StatusCode8" defaultValue={AcStatus.d_StatusCode8} 
                    onChange={handleInputChange8}  placeholder="Status Code ..." inputRef={register({ maxLength: 1}) } />
                    {errors.d_StatusCode8 && errors.d_StatusCode8.type === "maxLength" && <span id="Err_msg">Max length is 1</span>}
                    {errors.d_StatusCode8 && errors.d_StatusCode8.types && <span id="Err_msg">{errors.d_StatusCode8.types.message}</span>}
                </FormGroup>
                <FormGroup className="Col-2-2" label="">
                    <InputGroup id="inputStatusDesc" name="x_AC_SDESC8" defaultValue={AcStatus.x_AC_SDESC8} placeholder="Account Status ..." inputRef={register({ maxLength: 15}) } />
                    {errors.x_AC_SDESC8 && errors.x_AC_SDESC8.type === "maxLength" && <span id="Err_msg">Max length is 15</span>}
                    {errors.x_AC_SDESC8 && errors.x_AC_SDESC8.types && <span id="Err_msg">{errors.x_AC_SDESC8.types.message}</span>}
                </FormGroup>
                {IsShowMe8 && <FormGroup className="Col-4-1"   >
                    <RadioGroup
                        name="d_x_ALLOW_BUY8"
                        inline={true}
                        selectedValue={def_d_x_ALLOW_BUY8}
                        onChange={utils.handleStringChange(s => setdef_d_x_ALLOW_BUY8(s))}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}
                {IsShowMe8 && <FormGroup className="Col-5-1"    >
                    <RadioGroup
                        name="d_x_ALLOW_SELL8"
                        inline={true}
                        selectedValue={def_d_x_ALLOW_SELL8}
                        onChange={utils.handleStringChange(s => setdef_d_x_ALLOW_SELL8(s))}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}

                {IsShowMe8 && <FormGroup className="Col-6-1"   >
                    <RadioGroup
                        name="d_x_ALLOW_PYMT8"
                        inline={true}
                        selectedValue={def_d_x_ALLOW_PYMT8}
                        onChange={utils.handleStringChange(s => setdef_d_x_ALLOW_PYMT8(s))}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}

                {IsShowMe8 && <FormGroup className="Col-7-1"  >
                    <RadioGroup
                        name="d_x_ALLOW_REC8"
                        inline={true}
                        selectedValue={def_d_x_ALLOW_REC8}
                        onChange={utils.handleStringChange(s => setdef_d_x_ALLOW_REC8(s))}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}

                {IsShowMe8 && <FormGroup className="Col-8-1"   >
                    <RadioGroup
                        name="d_x_ALLOW_DEP8"
                        inline={true}
                        selectedValue={def_d_x_ALLOW_DEP8}
                        onChange={utils.handleStringChange(s => setdef_d_x_ALLOW_DEP8(s))}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}

                {IsShowMe8 && <FormGroup className="Col-9-1"    >
                    <RadioGroup
                        name="d_x_ALLOW_WD8"
                        inline={true}
                        selectedValue={def_d_x_ALLOW_WD8}
                        onChange={utils.handleStringChange(s => setdef_d_x_ALLOW_WD8(s))}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}        
            </div>
            <div className="Row">
                <FormGroup className="Col-1-1" label="">
                    <InputGroup id="inputStatusCode" disabled={( RESR_Code.indexOf(AcStatus.d_StatusCode9) >= 0 )} name="d_StatusCode9" defaultValue={AcStatus.d_StatusCode9} 
                    onChange={handleInputChange9}  placeholder="Status Code ..." inputRef={register({ maxLength: 1}) } />
                    {errors.d_StatusCode9 && errors.d_StatusCode9.type === "maxLength" && <span id="Err_msg">Max length is 1</span>}
                    {errors.d_StatusCode9 && errors.d_StatusCode9.types && <span id="Err_msg">{errors.d_StatusCode9.types.message}</span>}
                </FormGroup>
                <FormGroup className="Col-2-2" label="">
                    <InputGroup id="inputStatusDesc" name="x_AC_SDESC9" defaultValue={AcStatus.x_AC_SDESC9} placeholder="Account Status ..." inputRef={register({ maxLength: 15}) } />
                    {errors.x_AC_SDESC9 && errors.x_AC_SDESC9.type === "maxLength" && <span id="Err_msg">Max length is 15</span>}
                    {errors.x_AC_SDESC9 && errors.x_AC_SDESC9.types && <span id="Err_msg">{errors.x_AC_SDESC9.types.message}</span>}
                </FormGroup>
                {IsShowMe9 && <FormGroup className="Col-4-1"   >
                    <RadioGroup
                        name="d_x_ALLOW_BUY9"
                        inline={true}
                        selectedValue={def_d_x_ALLOW_BUY9}
                        onChange={utils.handleStringChange(s => setdef_d_x_ALLOW_BUY9(s))}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}
                {IsShowMe9 && <FormGroup className="Col-5-1"    >
                    <RadioGroup
                        name="d_x_ALLOW_SELL9"
                        inline={true}
                        selectedValue={def_d_x_ALLOW_SELL9}
                        onChange={utils.handleStringChange(s => setdef_d_x_ALLOW_SELL9(s))}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}

                {IsShowMe9 && <FormGroup className="Col-6-1"   >
                    <RadioGroup
                        name="d_x_ALLOW_PYMT9"
                        inline={true}
                        selectedValue={def_d_x_ALLOW_PYMT9}
                        onChange={utils.handleStringChange(s => setdef_d_x_ALLOW_PYMT9(s))}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}

                {IsShowMe9 && <FormGroup className="Col-7-1"  >
                    <RadioGroup
                        name="d_x_ALLOW_REC9"
                        inline={true}
                        selectedValue={def_d_x_ALLOW_REC9}
                        onChange={utils.handleStringChange(s => setdef_d_x_ALLOW_REC9(s))}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}

                {IsShowMe9 && <FormGroup className="Col-8-1"   >
                    <RadioGroup
                        name="d_x_ALLOW_DEP9"
                        inline={true}
                        selectedValue={def_d_x_ALLOW_DEP9}
                        onChange={utils.handleStringChange(s => setdef_d_x_ALLOW_DEP9(s))}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}

                {IsShowMe9 && <FormGroup className="Col-9-1"    >
                    <RadioGroup
                        name="d_x_ALLOW_WD9"
                        inline={true}
                        selectedValue={def_d_x_ALLOW_WD9}
                        onChange={utils.handleStringChange(s => setdef_d_x_ALLOW_WD9(s))}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}                  
            </div>
            <div className="Row">
                <FormGroup className="Col-1-1" label="">
                    <InputGroup id="inputStatusCode" disabled={( RESR_Code.indexOf(AcStatus.d_StatusCode10) >= 0 )} name="d_StatusCode10" defaultValue={AcStatus.d_StatusCode10}
                    onChange={handleInputChange10} placeholder="Status Code ..." inputRef={register({ maxLength: 1}) } />
                    {errors.d_StatusCode10 && errors.d_StatusCode10.type === "maxLength" && <span id="Err_msg">Max length is 1</span>}
                    {errors.d_StatusCode10 && errors.d_StatusCode10.types && <span id="Err_msg">{errors.d_StatusCode10.types.message}</span>}
                </FormGroup>
                <FormGroup className="Col-2-2" label="">
                    <InputGroup id="inputStatusDesc" name="x_AC_SDESC10" defaultValue={AcStatus.x_AC_SDESC10} placeholder="Account Status ..." inputRef={register({ maxLength: 15}) } />
                    {errors.x_AC_SDESC10 && errors.x_AC_SDESC10.type === "maxLength" && <span id="Err_msg">Max length is 15</span>}
                    {errors.x_AC_SDESC10 && errors.x_AC_SDESC10.types && <span id="Err_msg">{errors.x_AC_SDESC10.types.message}</span>}
                </FormGroup>
                {IsShowMe10 && <FormGroup className="Col-4-1"   >
                    <RadioGroup
                        name="d_x_ALLOW_BUY10"
                        inline={true}
                        selectedValue={def_d_x_ALLOW_BUY10}
                        onChange={utils.handleStringChange(s => setdef_d_x_ALLOW_BUY10(s))}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}
                {IsShowMe10 && <FormGroup className="Col-5-1"    >
                    <RadioGroup
                        name="d_x_ALLOW_SELL10"
                        inline={true}
                        selectedValue={def_d_x_ALLOW_SELL10}
                        onChange={utils.handleStringChange(s => setdef_d_x_ALLOW_SELL10(s))}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}

                {IsShowMe10 && <FormGroup className="Col-6-1"   >
                    <RadioGroup
                        name="d_x_ALLOW_PYMT10"
                        inline={true}
                        selectedValue={def_d_x_ALLOW_PYMT10}
                        onChange={utils.handleStringChange(s => setdef_d_x_ALLOW_PYMT10(s))}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}

                {IsShowMe10 && <FormGroup className="Col-7-1"  >
                    <RadioGroup
                        name="d_x_ALLOW_REC10"
                        inline={true}
                        selectedValue={def_d_x_ALLOW_REC10}
                        onChange={utils.handleStringChange(s => setdef_d_x_ALLOW_REC10(s))}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}

                {IsShowMe10 && <FormGroup className="Col-8-1"   >
                    <RadioGroup
                        name="d_x_ALLOW_DEP10"
                        inline={true}
                        selectedValue={def_d_x_ALLOW_DEP10}
                        onChange={utils.handleStringChange(s => setdef_d_x_ALLOW_DEP10(s))}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}

                {IsShowMe10 && <FormGroup className="Col-9-1"    >
                    <RadioGroup
                        name="d_x_ALLOW_WD10"
                        inline={true}
                        selectedValue={def_d_x_ALLOW_WD10}
                        onChange={utils.handleStringChange(s => setdef_d_x_ALLOW_WD10(s))}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}                  
            </div>
            <div className="Row">
                <FormGroup className="Col-1-1" label="">
                    <InputGroup id="inputStatusCode" disabled={( RESR_Code.indexOf(AcStatus.d_StatusCode11) >= 0 )} name="d_StatusCode11" defaultValue={AcStatus.d_StatusCode11} 
                    onChange={handleInputChange11} placeholder="Status Code ..." inputRef={register({ maxLength: 1}) } />
                    {errors.d_StatusCode11 && errors.d_StatusCode11.type === "maxLength" && <span id="Err_msg">Max length is 1</span>}
                    {errors.d_StatusCode11 && errors.d_StatusCode11.types && <span id="Err_msg">{errors.d_StatusCode11.types.message}</span>}
                </FormGroup>
                <FormGroup className="Col-2-2" label="">
                    <InputGroup id="inputStatusDesc" name="x_AC_SDESC11" defaultValue={AcStatus.x_AC_SDESC11} placeholder="Account Status ..." inputRef={register({ maxLength: 15}) } />
                    {errors.x_AC_SDESC11 && errors.x_AC_SDESC11.type === "maxLength" && <span id="Err_msg">Max length is 15</span>}
                    {errors.x_AC_SDESC11 && errors.x_AC_SDESC11.types && <span id="Err_msg">{errors.x_AC_SDESC11.types.message}</span>}
                </FormGroup>
                {IsShowMe11 && <FormGroup className="Col-4-1"   >
                    <RadioGroup
                        name="d_x_ALLOW_BUY11"
                        inline={true}
                        selectedValue={def_d_x_ALLOW_BUY11}
                        onChange={utils.handleStringChange(s => setdef_d_x_ALLOW_BUY11(s))}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}
                {IsShowMe11 && <FormGroup className="Col-5-1"    >
                    <RadioGroup
                        name="d_x_ALLOW_SELL11"
                        inline={true}
                        selectedValue={def_d_x_ALLOW_SELL11}
                        onChange={utils.handleStringChange(s => setdef_d_x_ALLOW_SELL11(s))}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}

                {IsShowMe11 && <FormGroup className="Col-6-1"   >
                    <RadioGroup
                        name="d_x_ALLOW_PYMT11"
                        inline={true}
                        selectedValue={def_d_x_ALLOW_PYMT11}
                        onChange={utils.handleStringChange(s => setdef_d_x_ALLOW_PYMT11(s))}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}

                {IsShowMe11 && <FormGroup className="Col-7-1"  >
                    <RadioGroup
                        name="d_x_ALLOW_REC11"
                        inline={true}
                        selectedValue={def_d_x_ALLOW_REC11}
                        onChange={utils.handleStringChange(s => setdef_d_x_ALLOW_REC11(s))}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}

                {IsShowMe11 && <FormGroup className="Col-8-1"   >
                    <RadioGroup
                        name="d_x_ALLOW_DEP11"
                        inline={true}
                        selectedValue={def_d_x_ALLOW_DEP11}
                        onChange={utils.handleStringChange(s => setdef_d_x_ALLOW_DEP11(s))}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}

                {IsShowMe11 && <FormGroup className="Col-9-1"    >
                    <RadioGroup
                        name="d_x_ALLOW_WD11"
                        inline={true}
                        selectedValue={def_d_x_ALLOW_WD11}
                        onChange={utils.handleStringChange(s => setdef_d_x_ALLOW_WD11(s))}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}                 
            </div>
            <div className="Row">
                <FormGroup className="Col-1-1" label="">
                    <InputGroup id="inputStatusCode" disabled={( RESR_Code.indexOf(AcStatus.d_StatusCode12) >= 0 )} name="d_StatusCode12" defaultValue={AcStatus.d_StatusCode12} 
                    onChange={handleInputChange12} placeholder="Status Code ..." inputRef={register({ maxLength: 1}) } />
                    {errors.d_StatusCode12 && errors.d_StatusCode12.type === "maxLength" && <span id="Err_msg">Max length is 1</span>}
                    {errors.d_StatusCode12 && errors.d_StatusCode12.types && <span id="Err_msg">{errors.d_StatusCode12.types.message}</span>}
                </FormGroup>
                <FormGroup className="Col-2-2" label="">
                    <InputGroup id="inputStatusDesc" name="x_AC_SDESC12" defaultValue={AcStatus.x_AC_SDESC12} placeholder="Account Status ..." inputRef={register({ maxLength: 15}) } />
                    {errors.x_AC_SDESC12 && errors.x_AC_SDESC12.type === "maxLength" && <span id="Err_msg">Max length is 15</span>}
                    {errors.x_AC_SDESC12 && errors.x_AC_SDESC12.types && <span id="Err_msg">{errors.x_AC_SDESC12.types.message}</span>}
                </FormGroup>
                {IsShowMe12 && <FormGroup className="Col-4-1"   >
                    <RadioGroup
                        name="d_x_ALLOW_BUY12"
                        inline={true}
                        selectedValue={def_d_x_ALLOW_BUY12}
                        onChange={utils.handleStringChange(s => setdef_d_x_ALLOW_BUY12(s))}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}

                {IsShowMe12 &&  <FormGroup className="Col-5-1"    >
                    <RadioGroup
                        name="d_x_ALLOW_SELL12"
                        inline={true}
                        selectedValue={def_d_x_ALLOW_SELL12}
                        onChange={utils.handleStringChange(s => setdef_d_x_ALLOW_SELL12(s))}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}

                {IsShowMe12 && <FormGroup className="Col-6-1"   >
                    <RadioGroup
                        name="d_x_ALLOW_PYMT12"
                        inline={true}
                        selectedValue={def_d_x_ALLOW_PYMT12}
                        onChange={utils.handleStringChange(s => setdef_d_x_ALLOW_PYMT12(s))}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}

                {IsShowMe12 && <FormGroup className="Col-7-1"  >
                    <RadioGroup
                        name="d_x_ALLOW_REC12"
                        inline={true}
                        selectedValue={def_d_x_ALLOW_REC12}
                        onChange={utils.handleStringChange(s => setdef_d_x_ALLOW_REC12(s))}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}

                {IsShowMe12 && <FormGroup className="Col-8-1"   >
                    <RadioGroup
                        name="d_x_ALLOW_DEP12"
                        inline={true}
                        selectedValue={def_d_x_ALLOW_DEP12}
                        onChange={utils.handleStringChange(s => setdef_d_x_ALLOW_DEP12(s))}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}

                {IsShowMe12 && <FormGroup className="Col-9-1"    >
                    <RadioGroup
                        name="d_x_ALLOW_WD12"
                        inline={true}
                        selectedValue={def_d_x_ALLOW_WD12}
                        onChange={utils.handleStringChange(s => setdef_d_x_ALLOW_WD12(s))}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}                  
            </div>
            <div className="Row">
                 
                <FormGroup className="Col-1-1" label="">
                    <InputGroup id="inputStatusCode" disabled={( RESR_Code.indexOf(AcStatus.d_StatusCode13) >= 0 )} name="d_StatusCode13" defaultValue={AcStatus.d_StatusCode13}
                    onChange={handleInputChange13} placeholder="Status Code ..." inputRef={register({ maxLength: 1}) } />
                    {errors.d_StatusCode13 && errors.d_StatusCode13.type === "maxLength" && <span id="Err_msg">Max length is 1</span>}
                    {errors.d_StatusCode13 && errors.d_StatusCode13.types && <span id="Err_msg">{errors.d_StatusCode13.types.message}</span>}
                </FormGroup>
                <FormGroup className="Col-2-2" label="">
                    <InputGroup id="inputStatusDesc" name="x_AC_SDESC13" defaultValue={AcStatus.x_AC_SDESC13} placeholder="Account Status ..." inputRef={register({ maxLength: 15}) } />
                    {errors.x_AC_SDESC13 && errors.x_AC_SDESC13.type === "maxLength" && <span id="Err_msg">Max length is 15</span>}
                    {errors.x_AC_SDESC13 && errors.x_AC_SDESC13.types && <span id="Err_msg">{errors.x_AC_SDESC13.types.message}</span>}
                </FormGroup>
                {IsShowMe13 && <FormGroup className="Col-4-1"   >
                    <RadioGroup
                        name="d_x_ALLOW_BUY13"
                        inline={true}
                        selectedValue={def_d_x_ALLOW_BUY13}
                        onChange={utils.handleStringChange(s => setdef_d_x_ALLOW_BUY13(s))}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}
                {IsShowMe13 && <FormGroup className="Col-5-1"    >
                    <RadioGroup
                        name="d_x_ALLOW_SELL13"
                        inline={true}
                        selectedValue={def_d_x_ALLOW_SELL13}
                        onChange={utils.handleStringChange(s => setdef_d_x_ALLOW_SELL13(s))}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}

                {IsShowMe13 && <FormGroup className="Col-6-1"   >
                    <RadioGroup
                        name="d_x_ALLOW_PYMT13"
                        inline={true}
                        selectedValue={def_d_x_ALLOW_PYMT13}
                        onChange={utils.handleStringChange(s => setdef_d_x_ALLOW_PYMT13(s))}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}

                {IsShowMe13 && <FormGroup className="Col-7-1"  >
                    <RadioGroup
                        name="d_x_ALLOW_REC13"
                        inline={true}
                        selectedValue={def_d_x_ALLOW_REC13}
                        onChange={utils.handleStringChange(s => setdef_d_x_ALLOW_REC13(s))}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}

                {IsShowMe13 && <FormGroup className="Col-8-1"   >
                    <RadioGroup
                        name="d_x_ALLOW_DEP13"
                        inline={true}
                        selectedValue={def_d_x_ALLOW_DEP13}
                        onChange={utils.handleStringChange(s => setdef_d_x_ALLOW_DEP13(s))}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}

                {IsShowMe13 && <FormGroup className="Col-9-1"    >
                    <RadioGroup
                        name="d_x_ALLOW_WD13"
                        inline={true}
                        selectedValue={def_d_x_ALLOW_WD13}
                        onChange={utils.handleStringChange(s => setdef_d_x_ALLOW_WD13(s))}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}                  
            </div>
            <div className="Row">
                <FormGroup className="Col-1-1" label="">
                    <InputGroup id="inputStatusCode" disabled={( RESR_Code.indexOf(AcStatus.d_StatusCode14) >= 0 )} name="d_StatusCode14" defaultValue={AcStatus.d_StatusCode14}
                    onChange={handleInputChange14} placeholder="Status Code ..." inputRef={register({ maxLength: 1}) } />
                    {errors.d_StatusCode14 && errors.d_StatusCode14.type === "maxLength" && <span id="Err_msg">Max length is 1</span>}
                    {errors.d_StatusCode14 && errors.d_StatusCode14.types && <span id="Err_msg">{errors.d_StatusCode14.types.message}</span>}
                </FormGroup>
                <FormGroup className="Col-2-2" label="">
                    <InputGroup id="inputStatusDesc" name="x_AC_SDESC14" defaultValue={AcStatus.x_AC_SDESC14} placeholder="Account Status ..." inputRef={register({ maxLength: 15}) } />
                    {errors.x_AC_SDESC14 && errors.x_AC_SDESC14.type === "maxLength" && <span id="Err_msg">Max length is 15</span>}
                    {errors.x_AC_SDESC14 && errors.x_AC_SDESC14.types && <span id="Err_msg">{errors.x_AC_SDESC14.types.message}</span>}
                </FormGroup>
                {IsShowMe14 && <FormGroup className="Col-4-1"   >
                    <RadioGroup
                        name="d_x_ALLOW_BUY14"
                        inline={true}
                        selectedValue={def_d_x_ALLOW_BUY14}
                        onChange={utils.handleStringChange(s => setdef_d_x_ALLOW_BUY14(s))}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}
                {IsShowMe14 && <FormGroup className="Col-5-1"    >
                    <RadioGroup
                        name="d_x_ALLOW_SELL14"
                        inline={true}
                        selectedValue={def_d_x_ALLOW_SELL14}
                        onChange={utils.handleStringChange(s => setdef_d_x_ALLOW_SELL14(s))}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}

                {IsShowMe14 && <FormGroup className="Col-6-1"   >
                    <RadioGroup
                        name="d_x_ALLOW_PYMT14"
                        inline={true}
                        selectedValue={def_d_x_ALLOW_PYMT14}
                        onChange={utils.handleStringChange(s => setdef_d_x_ALLOW_PYMT14(s))}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}

                {IsShowMe14 && <FormGroup className="Col-7-1"  >
                    <RadioGroup
                        name="d_x_ALLOW_REC14"
                        inline={true}
                        selectedValue={def_d_x_ALLOW_REC14}
                        onChange={utils.handleStringChange(s => setdef_d_x_ALLOW_REC14(s))}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}

                {IsShowMe14 && <FormGroup className="Col-8-1"   >
                    <RadioGroup
                        name="d_x_ALLOW_DEP14"
                        inline={true}
                        selectedValue={def_d_x_ALLOW_DEP14}
                        onChange={utils.handleStringChange(s => setdef_d_x_ALLOW_DEP14(s))}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}

                {IsShowMe14 && <FormGroup className="Col-9-1"    >
                    <RadioGroup
                        name="d_x_ALLOW_WD14"
                        inline={true}
                        selectedValue={def_d_x_ALLOW_WD14}
                        onChange={utils.handleStringChange(s => setdef_d_x_ALLOW_WD14(s))}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}                  
            </div>
            <div className="Row">              
                <FormGroup className="Col-1-1" label="">
                    <InputGroup id="inputStatusCode" disabled={( RESR_Code.indexOf(AcStatus.d_StatusCode15) >= 0 )} name="d_StatusCode15" defaultValue={AcStatus.d_StatusCode15} 
                    onChange={handleInputChange15} placeholder="Status Code ..." inputRef={register({ maxLength: 1}) } />
                    {errors.d_StatusCode15 && errors.d_StatusCode15.type === "maxLength" && <span id="Err_msg">Max length is 1</span>}
                    {errors.d_StatusCode15 && errors.d_StatusCode15.types && <span id="Err_msg">{errors.d_StatusCode15.types.message}</span>}
                </FormGroup>
                <FormGroup className="Col-2-2" label="">
                    <InputGroup id="inputStatusDesc" name="x_AC_SDESC15" defaultValue={AcStatus.x_AC_SDESC15} placeholder="Account Status ..." inputRef={register({ maxLength: 15}) } />
                    {errors.x_AC_SDESC15 && errors.x_AC_SDESC15.type === "maxLength" && <span id="Err_msg">Max length is 15</span>}
                    {errors.x_AC_SDESC15 && errors.x_AC_SDESC15.types && <span id="Err_msg">{errors.x_AC_SDESC15.types.message}</span>}
                </FormGroup>
                {IsShowMe15 && <FormGroup className="Col-4-1"   >
                    <RadioGroup
                        name="d_x_ALLOW_BUY15"
                        inline={true}
                        selectedValue={def_d_x_ALLOW_BUY15}
                        onChange={utils.handleStringChange(s => setdef_d_x_ALLOW_BUY15(s))}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}
                {IsShowMe15 && <FormGroup className="Col-5-1"    >
                    <RadioGroup
                        name="d_x_ALLOW_SELL15"
                        inline={true}
                        selectedValue={def_d_x_ALLOW_SELL15}
                        onChange={utils.handleStringChange(s => setdef_d_x_ALLOW_SELL15(s))}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}

                {IsShowMe15 && <FormGroup className="Col-6-1"   >
                    <RadioGroup
                        name="d_x_ALLOW_PYMT15"
                        inline={true}
                        selectedValue={def_d_x_ALLOW_PYMT15}
                        onChange={utils.handleStringChange(s => setdef_d_x_ALLOW_PYMT15(s))}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}

                {IsShowMe15 && <FormGroup className="Col-7-1"  >
                    <RadioGroup
                        name="d_x_ALLOW_REC15"
                        inline={true}
                        selectedValue={def_d_x_ALLOW_REC15}
                        onChange={utils.handleStringChange(s => setdef_d_x_ALLOW_REC15(s))}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}

                {IsShowMe15 && <FormGroup className="Col-8-1"   >
                    <RadioGroup
                        name="d_x_ALLOW_DEP15"
                        inline={true}
                        selectedValue={def_d_x_ALLOW_DEP15}
                        onChange={utils.handleStringChange(s => setdef_d_x_ALLOW_DEP15(s))}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}

                {IsShowMe15 && <FormGroup className="Col-9-1"    >
                    <RadioGroup
                        name="d_x_ALLOW_WD15"
                        inline={true}
                        selectedValue={def_d_x_ALLOW_WD15}
                        onChange={utils.handleStringChange(s => setdef_d_x_ALLOW_WD15(s))}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}                  
            </div>
            <div className="Row">
                <FormGroup className="Col-1-1" label="">
                    <InputGroup id="inputStatusCode" disabled={( RESR_Code.indexOf(AcStatus.d_StatusCode16) >= 0 )} name="d_StatusCode16" defaultValue={AcStatus.d_StatusCode16}
                    onChange={handleInputChange16} placeholder="Status Code ..." inputRef={register({ maxLength: 1}) } />
                    {errors.d_StatusCode16 && errors.d_StatusCode16.type === "maxLength" && <span id="Err_msg">Max length is 1</span>}
                    {errors.d_StatusCode16 && errors.d_StatusCode16.types && <span id="Err_msg">{errors.d_StatusCode16.types.message}</span>}
                </FormGroup>
                <FormGroup className="Col-2-2" label="">
                    <InputGroup id="inputStatusDesc" name="x_AC_SDESC16" defaultValue={AcStatus.x_AC_SDESC16} placeholder="Account Status ..." inputRef={register({ maxLength: 15}) } />
                    {errors.x_AC_SDESC16 && errors.x_AC_SDESC16.type === "maxLength" && <span id="Err_msg">Max length is 15</span>}
                    {errors.x_AC_SDESC16 && errors.x_AC_SDESC16.types && <span id="Err_msg">{errors.x_AC_SDESC16.types.message}</span>}
                </FormGroup>
                {IsShowMe16 && <FormGroup className="Col-4-1"   >
                    <RadioGroup
                        name="d_x_ALLOW_BUY16"
                        inline={true}
                        selectedValue={def_d_x_ALLOW_BUY16}
                        onChange={utils.handleStringChange(s => setdef_d_x_ALLOW_BUY16(s))}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}
                {IsShowMe16 && <FormGroup className="Col-5-1"    >
                    <RadioGroup
                        name="d_x_ALLOW_SELL16"
                        inline={true}
                        selectedValue={def_d_x_ALLOW_SELL16}
                        onChange={utils.handleStringChange(s => setdef_d_x_ALLOW_SELL16(s))}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}

                {IsShowMe16 && <FormGroup className="Col-6-1"   >
                    <RadioGroup
                        name="d_x_ALLOW_PYMT16"
                        inline={true}
                        selectedValue={def_d_x_ALLOW_PYMT16}
                        onChange={utils.handleStringChange(s => setdef_d_x_ALLOW_PYMT16(s))}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}

                {IsShowMe16 && <FormGroup className="Col-7-1"  >
                    <RadioGroup
                        name="d_x_ALLOW_REC16"
                        inline={true}
                        selectedValue={def_d_x_ALLOW_REC16}
                        onChange={utils.handleStringChange(s => setdef_d_x_ALLOW_REC16(s))}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}

                {IsShowMe16 && <FormGroup className="Col-8-1"   >
                    <RadioGroup
                        name="d_x_ALLOW_DEP16"
                        inline={true}
                        selectedValue={def_d_x_ALLOW_DEP16}
                        onChange={utils.handleStringChange(s => setdef_d_x_ALLOW_DEP16(s))}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}

                {IsShowMe16 && <FormGroup className="Col-9-1"    >
                    <RadioGroup
                        name="d_x_ALLOW_WD16"
                        inline={true}
                        selectedValue={def_d_x_ALLOW_WD16}
                        onChange={utils.handleStringChange(s => setdef_d_x_ALLOW_WD16(s))}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}                  
            </div>
            <div className="Row">
                <FormGroup className="Col-1-1" label="">
                    <InputGroup id="inputStatusCode" disabled={( RESR_Code.indexOf(AcStatus.d_StatusCode17) >= 0 )} name="d_StatusCode17" defaultValue={AcStatus.d_StatusCode17}
                    onChange={handleInputChange17} placeholder="Status Code ..." inputRef={register({ maxLength: 1}) } />
                    {errors.d_StatusCode17 && errors.d_StatusCode17.type === "maxLength" && <span id="Err_msg">Max length is 1</span>}
                    {errors.d_StatusCode17 && errors.d_StatusCode17.types && <span id="Err_msg">{errors.d_StatusCode17.types.message}</span>}
                </FormGroup>
                <FormGroup className="Col-2-2" label="">
                    <InputGroup id="inputStatusDesc" name="x_AC_SDESC17" defaultValue={AcStatus.x_AC_SDESC17} placeholder="Account Status ..." inputRef={register({ maxLength: 15}) } />
                    {errors.x_AC_SDESC17 && errors.x_AC_SDESC17.type === "maxLength" && <span id="Err_msg">Max length is 15</span>}
                    {errors.x_AC_SDESC17 && errors.x_AC_SDESC17.types && <span id="Err_msg">{errors.x_AC_SDESC17.types.message}</span>}
                </FormGroup>
                {IsShowMe17 && <FormGroup className="Col-4-1"   >
                    <RadioGroup
                        name="d_x_ALLOW_BUY17"
                        inline={true}
                        selectedValue={def_d_x_ALLOW_BUY17}
                        onChange={utils.handleStringChange(s => setdef_d_x_ALLOW_BUY17(s))}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}
                {IsShowMe17 && <FormGroup className="Col-5-1"    >
                    <RadioGroup
                        name="d_x_ALLOW_SELL17"
                        inline={true}
                        selectedValue={def_d_x_ALLOW_SELL17}
                        onChange={utils.handleStringChange(s => setdef_d_x_ALLOW_SELL17(s))}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}

                {IsShowMe17 && <FormGroup className="Col-6-1"   >
                    <RadioGroup
                        name="d_x_ALLOW_PYMT17"
                        inline={true}
                        selectedValue={def_d_x_ALLOW_PYMT17}
                        onChange={utils.handleStringChange(s => setdef_d_x_ALLOW_PYMT17(s))}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}

                {IsShowMe17 && <FormGroup className="Col-7-1"  >
                    <RadioGroup
                        name="d_x_ALLOW_REC17"
                        inline={true}
                        selectedValue={def_d_x_ALLOW_REC17}
                        onChange={utils.handleStringChange(s => setdef_d_x_ALLOW_REC17(s))}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}

                {IsShowMe17 && <FormGroup className="Col-8-1"   >
                    <RadioGroup
                        name="d_x_ALLOW_DEP17"
                        inline={true}
                        selectedValue={def_d_x_ALLOW_DEP17}
                        onChange={utils.handleStringChange(s => setdef_d_x_ALLOW_DEP17(s))}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}

                {IsShowMe17 && <FormGroup className="Col-9-1"    >
                    <RadioGroup
                        name="d_x_ALLOW_WD17"
                        inline={true}
                        selectedValue={def_d_x_ALLOW_WD17}
                        onChange={utils.handleStringChange(s => setdef_d_x_ALLOW_WD17(s))}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}                  
            </div>
            <div className="Row">
                <FormGroup className="Col-1-1" label="">
                    <InputGroup id="inputStatusCode" disabled={( RESR_Code.indexOf(AcStatus.d_StatusCode18) >= 0 )} name="d_StatusCode18" defaultValue={AcStatus.d_StatusCode18}
                    onChange={handleInputChange18} placeholder="Status Code ..." inputRef={register({ maxLength: 1}) } />
                    {errors.d_StatusCode18 && errors.d_StatusCode18.type === "maxLength" && <span id="Err_msg">Max length is 1</span>}
                    {errors.d_StatusCode18 && errors.d_StatusCode18.types && <span id="Err_msg">{errors.d_StatusCode18.types.message}</span>}
                </FormGroup>
                <FormGroup className="Col-2-2" label="">
                    <InputGroup id="inputStatusDesc" name="x_AC_SDESC18" defaultValue={AcStatus.x_AC_SDESC18} placeholder="Account Status ..." inputRef={register({ maxLength: 15}) } />
                    {errors.x_AC_SDESC18 && errors.x_AC_SDESC18.type === "maxLength" && <span id="Err_msg">Max length is 15</span>}
                    {errors.x_AC_SDESC18 && errors.x_AC_SDESC18.types && <span id="Err_msg">{errors.x_AC_SDESC18.types.message}</span>}
                </FormGroup>
                {IsShowMe18 && <FormGroup className="Col-4-1"   >
                    <RadioGroup
                        name="d_x_ALLOW_BUY18"
                        inline={true}
                        selectedValue={def_d_x_ALLOW_BUY18}
                        onChange={utils.handleStringChange(s => setdef_d_x_ALLOW_BUY18(s))}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}
                {IsShowMe18 && <FormGroup className="Col-5-1"    >
                    <RadioGroup
                        name="d_x_ALLOW_SELL18"
                        inline={true}
                        selectedValue={def_d_x_ALLOW_SELL18}
                        onChange={utils.handleStringChange(s => setdef_d_x_ALLOW_SELL18(s))}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}

                {IsShowMe18 && <FormGroup className="Col-6-1"   >
                    <RadioGroup
                        name="d_x_ALLOW_PYMT18"
                        inline={true}
                        selectedValue={def_d_x_ALLOW_PYMT18}
                        onChange={utils.handleStringChange(s => setdef_d_x_ALLOW_PYMT18(s))}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}

                {IsShowMe18 && <FormGroup className="Col-7-1"  >
                    <RadioGroup
                        name="d_x_ALLOW_REC18"
                        inline={true}
                        selectedValue={def_d_x_ALLOW_REC18}
                        onChange={utils.handleStringChange(s => setdef_d_x_ALLOW_REC18(s))}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}

                {IsShowMe18 && <FormGroup className="Col-8-1"   >
                    <RadioGroup
                        name="d_x_ALLOW_DEP18"
                        inline={true}
                        selectedValue={def_d_x_ALLOW_DEP18}
                        onChange={utils.handleStringChange(s => setdef_d_x_ALLOW_DEP18(s))}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}

                {IsShowMe18 && <FormGroup className="Col-9-1"    >
                    <RadioGroup
                        name="d_x_ALLOW_WD18"
                        inline={true}
                        selectedValue={def_d_x_ALLOW_WD18}
                        onChange={utils.handleStringChange(s => setdef_d_x_ALLOW_WD18(s))}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}                  
            </div>
            <div className="Row">
                <FormGroup className="Col-1-1" label="">
                    <InputGroup id="inputStatusCode" disabled={( RESR_Code.indexOf(AcStatus.d_StatusCode19) >= 0 )} name="d_StatusCode19" defaultValue={AcStatus.d_StatusCode19}
                    onChange={handleInputChange19} placeholder="Status Code ..." inputRef={register({ maxLength: 1}) } />
                    {errors.d_StatusCode19 && errors.d_StatusCode19.type === "maxLength" && <span id="Err_msg">Max length is 1</span>}
                    {errors.d_StatusCode19 && errors.d_StatusCode19.types && <span id="Err_msg">{errors.d_StatusCode19.types.message}</span>}
                </FormGroup>
                <FormGroup className="Col-2-2" label="">
                    <InputGroup id="inputStatusDesc" name="x_AC_SDESC19" defaultValue={AcStatus.x_AC_SDESC19} placeholder="Account Status ..." inputRef={register({ maxLength: 15}) } />
                    {errors.x_AC_SDESC19 && errors.x_AC_SDESC19.type === "maxLength" && <span id="Err_msg">Max length is 15</span>}
                    {errors.x_AC_SDESC19 && errors.x_AC_SDESC19.types && <span id="Err_msg">{errors.x_AC_SDESC19.types.message}</span>}
                </FormGroup>
                {IsShowMe19 &&  <FormGroup className="Col-4-1"   >
                    <RadioGroup
                        name="d_x_ALLOW_BUY19"
                        inline={true}
                        selectedValue={def_d_x_ALLOW_BUY19}
                        onChange={utils.handleStringChange(s => setdef_d_x_ALLOW_BUY19(s))}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}
                {IsShowMe19 &&  <FormGroup className="Col-5-1"    >
                    <RadioGroup
                        name="d_x_ALLOW_SELL19"
                        inline={true}
                        selectedValue={def_d_x_ALLOW_SELL19}
                        onChange={utils.handleStringChange(s => setdef_d_x_ALLOW_SELL19(s))}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}

                {IsShowMe19 &&  <FormGroup className="Col-6-1"   >
                    <RadioGroup
                        name="d_x_ALLOW_PYMT19"
                        inline={true}
                        selectedValue={def_d_x_ALLOW_PYMT19}
                        onChange={utils.handleStringChange(s => setdef_d_x_ALLOW_PYMT19(s))}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}

                {IsShowMe19 &&  <FormGroup className="Col-7-1"  >
                    <RadioGroup
                        name="d_x_ALLOW_REC19"
                        inline={true}
                        selectedValue={def_d_x_ALLOW_REC19}
                        onChange={utils.handleStringChange(s => setdef_d_x_ALLOW_REC19(s))}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}

                {IsShowMe19 &&  <FormGroup className="Col-8-1"   >
                    <RadioGroup
                        name="d_x_ALLOW_DEP19"
                        inline={true}
                        selectedValue={def_d_x_ALLOW_DEP19}
                        onChange={utils.handleStringChange(s => setdef_d_x_ALLOW_DEP19(s))}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}

                {IsShowMe19 &&  <FormGroup className="Col-9-1"    >
                    <RadioGroup
                        name="d_x_ALLOW_WD19"
                        inline={true}
                        selectedValue={def_d_x_ALLOW_WD19}
                        onChange={utils.handleStringChange(s => setdef_d_x_ALLOW_WD19(s))}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}            
            </div>
            <div className="Row">
                <FormGroup className="Col-1-1" label="">
                    <InputGroup id="inputStatusCode" disabled={( RESR_Code.indexOf(AcStatus.d_StatusCode20) >= 0 )} name="d_StatusCode20" defaultValue={AcStatus.d_StatusCode20} 
                    onChange={handleInputChange20} placeholder="Status Code ..." inputRef={register({ maxLength: 1}) } />
                    {errors.d_StatusCode20 && errors.d_StatusCode20.type === "maxLength" && <span id="Err_msg">Max length is 1</span>}
                    {errors.d_StatusCode20 && errors.d_StatusCode20.types && <span id="Err_msg">{errors.d_StatusCode20.types.message}</span>}
                </FormGroup>
                <FormGroup className="Col-2-2" label="">
                    <InputGroup id="inputStatusDesc" name="x_AC_SDESC20" defaultValue={AcStatus.x_AC_SDESC20} placeholder="Account Status ..." inputRef={register({ maxLength: 15}) } />
                    {errors.x_AC_SDESC20 && errors.x_AC_SDESC20.type === "maxLength" && <span id="Err_msg">Max length is 15</span>}
                    {errors.x_AC_SDESC20 && errors.x_AC_SDESC20.types && <span id="Err_msg">{errors.x_AC_SDESC20.types.message}</span>}
                </FormGroup>
                {IsShowMe20 &&  <FormGroup className="Col-4-1"   >
                    <RadioGroup
                        name="d_x_ALLOW_BUY20"
                        inline={true}
                        selectedValue={def_d_x_ALLOW_BUY20}
                        onChange={utils.handleStringChange(s => setdef_d_x_ALLOW_BUY20(s))}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}
                {IsShowMe20 &&  <FormGroup className="Col-5-1"    >
                    <RadioGroup
                        name="d_x_ALLOW_SELL20"
                        inline={true}
                        selectedValue={def_d_x_ALLOW_SELL20}
                        onChange={utils.handleStringChange(s => setdef_d_x_ALLOW_SELL20(s))}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}

                {IsShowMe20 &&  <FormGroup className="Col-6-1"   >
                    <RadioGroup
                        name="d_x_ALLOW_PYMT20"
                        inline={true}
                        selectedValue={def_d_x_ALLOW_PYMT20}
                        onChange={utils.handleStringChange(s => setdef_d_x_ALLOW_PYMT20(s))}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}

                {IsShowMe20 &&  <FormGroup className="Col-7-1"  >
                    <RadioGroup
                        name="d_x_ALLOW_REC20"
                        inline={true}
                        selectedValue={def_d_x_ALLOW_REC20}
                        onChange={utils.handleStringChange(s => setdef_d_x_ALLOW_REC20(s))}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}

                {IsShowMe20 &&  <FormGroup className="Col-8-1"  >
                    <RadioGroup
                    
                        name="d_x_ALLOW_DEP20"
                        inline={true}
                        selectedValue={def_d_x_ALLOW_DEP20}
                        onChange={utils.handleStringChange(s => setdef_d_x_ALLOW_DEP20(s))}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}

                {IsShowMe20 &&  <FormGroup className="Col-9-1"    >
                    <RadioGroup
                        name="d_x_ALLOW_WD20"
                        inline={true}
                        selectedValue={def_d_x_ALLOW_WD20}
                        onChange={utils.handleStringChange(s => setdef_d_x_ALLOW_WD20(s))}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                </FormGroup>}                  
            </div>
        
        </form>
    )
}



interface AcStatusMainProps {
    gsb: AxiosInstance
}

const toaster = Toaster.create({
    position: Position.TOP,
})

function AcStatusMain({ gsb }: AcStatusMainProps) {

    const imgWait = <img className="WaitIcon" src={svgWait2} alt="wait" />
    const coLogo = <img className="coLogo" src="coLogo.gif" alt="Co Logo" />

    const [data, setData] = useState([] as AcStatusInfo[])


    const [searchKey, setSearchKey] = useState("OpenDate")
    const [searchValue, setSearchValue] = useState("")

    const [showFilters, setShowFilters] = useState(false)
    const [showButton, setshowButton] = useState(false)


    const [nPage, setnPage] = useState(0)
    const [nTotalPage, setnTotalPage] = useState(0)
    const [aPageNumber, setaPageNumber] = useState([] as PageInfo[])
    const [MoblieDev, setMoblieDev] = useState(false)
    const [ShowWait, setShowWait] = useState(false)
    const [searchLimit, setSearchLimit] = useState(50)
    const [searchBackward, setSearchBackward] = useState(false)

    const [selectedTabId, setSelectedTabId] = useState("Detail")

    const [currentAcStatus, setcurrentAcStatus] = useState({} as AcStatusInfo)

    const [BlankAcStatus, setBlankAcStatus] = useState({} as AcStatusInfo)


    const [currentMode, setCurrentMode] = useState("show")
    const [isShowAlert1, setisShowAlert1] = useState(false)
    const [ShowAlert1Msg, setShowAlert1Msg] = useState("")
    const [isShowAlert2, setisShowAlert2] = useState(false)
    const [ShowAlert2Msg, setShowAlert2Msg] = useState("")

    const [isDark, setIsDark] = useState(document.getElementById("body")?.classList.contains("bp4-dark"))

    const [CO_NAME, setCO_NAME] = useState("")
    const [companyLogoName, setcompanyLogoName] = useState("")
    const [SBPath, setSBPath] = useState("")
    

    
    const [TRAN_DATE, setTRAN_DATE] = useState(utils.formatNumber(new Date()))
    const [SETL_DATE, setSETL_DATE] = useState(utils.formatNumber(new Date()))
    const [userKey, setuserKey] = useState("")
    const [cardOpen01, setcardOpen01] = useState("cardOpen01-Theme0")

    //gsb default value
    BlankAcStatus.d_StatusCode1 = "A"
    BlankAcStatus.x_AC_SDESC1 = "ACTIVE"
    BlankAcStatus.d_StatusCode2 = "C"
    BlankAcStatus.x_AC_SDESC2 = "CLOSED"
    BlankAcStatus.d_StatusCode3 = "S"
    BlankAcStatus.x_AC_SDESC3 = "SUSPENDED"
    BlankAcStatus.d_StatusCode4 = "R"
    BlankAcStatus.x_AC_SDESC4 = "RESTRICTED"
    

    //const [def_d_x_AllowBuy, setdef_d_x_AllowBuy] = useState(currentAcStatus.x_ALLOW_BUY === "Y" ? true : false)

    useEffect(() => {
        (async () => {
            try {
                // get GsbFlag from SB.XBS
                const res = await gsb.post('/GsbFlag');
                //console.log("AcStatusMain disp user_key: ", res.data.Flag.user_key)
                //console.log("AcStatusMain disp MULTI_MKT: ", res.data.Flag.MULTI_MKT)
                //console.log("AcStatusMain disp data.Flag: ", res.data.Flag)
                GsbFlag = res.data.Flag;
                //console.log("AcStatusMain disp GsbFlag: ", GsbFlag)
                //console.log("AcStatusMain disp GsbFlag.lang: ", GsbFlag.lang)
                //console.log("AcStatusMain disp dateFormat: ", dateFormat)
                console.log("GsbFlag.user_key: ", GsbFlag.user_key)
                //console.log("GsbFlag.UserID: ", GsbFlag.UserID)
                //console.log("AcStatusMain disp GsbFlag.MULTI_MKT: ", sbFlag.MULTI_MKT)
                //console.log("AcStatusMain disp GsbFlag.MGNGP_USER: ", GsbFlag.MGNGP_USER)
                //console.log("AcStatusMain disp GsbFlag.CO_NAME: ", GsbFlag.CO_NAME)
                setCO_NAME( GsbFlag.CO_NAME) ;
                setcompanyLogoName( GsbFlag.companyLogoName) ;
                setSBPath( GsbFlag.SBPath) ;
                setTRAN_DATE(GsbFlag.TRAN_DATE ) ;
                setSETL_DATE(GsbFlag.SETL_DATE ) ;
                setuserKey(GsbFlag.user_key) ;

                //console.log("AcStatusMain isProduction: ", GsbFlag.isProduction)
                if ( GsbFlag.isProduction == "Y" ) {
                    setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME1);
                } else {
                    setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME2);
                }
                //console.log("set StatusList: ", StatusList)

            } catch (error) {
                utils.showError(error)
            }
        })()
    }, [gsb, currentMode])


    useEffect(() => {

        //console.log("MenuBar cardOpen01", cardOpen01)        
        if ( cardOpen01.substr(0,17) === "cardOpen01-Theme8" ) {
            document.getElementById("body")?.classList.add("bp4-dark")
            setIsDark(true)
        } else {
            document.getElementById("body")?.classList.remove("bp4-dark")
            setIsDark(false)
        }


    }, [gsb, GsbFlag, cardOpen01])


    useEffect(() => {

        setnPage(1)
        ;

        (async () => {
            try {
                const res = await gsb.post('/Master',
                    {   sb_data: {
                            by: "",
                            start: "",
                            nPage: 1,
                            limit: 0,
                            backward: false,
                            SortByName: false,
                                    filters: {
                            }
                        },
                        cPgmId: "AcStatus",
                        cAction: "ListRec",
                    });
               //console.log("AcStatusMain AcStatusInfo ", res.data.data[0]) 
                setData(res.data.data[0])
                if (res.data.data.length > 0) {
                    setcurrentAcStatus(res.data.data[0])
                }

                //console.log("main currentAcStatus", currentAcStatus)
                setCurrentMode("show")

                setshowButton(false)

            } catch (error) {
                utils.showError(error)
            }
        })()
    }, [])



    const PrevRecProcess = async (AcStatus: AcStatusInfo) => {
/*        
        try {
            //console.log("call PrevRecProcess", ac)
            const res = await gsb.post('/Master', {sb_data: ac, cPgmId: "AcStatus", cAction: "PrevRec"})
            //console.log("PrevRecProcess res.data : ", res.data.data)
            for (let i = 0; i < data.length; i++) {
                if (data[i].d_acCode === res.data.data.d_acCode) {
                    data[i] = { ...data[i], ...res.data.data }
                    setData(data)
                    break
                }
            }
            setcurrentAcStatus(res.data.data)
            setCurrentMode("show")
        } catch (error) {
            utils.showError(error)
        }
*/        
    }

    const DeleteProcess = async (AcStatus: AcStatusInfo) => {
/*        
        try {
            //console.log("call DeleteProcess", ac)
            const res = await gsb.post('/Master', {sb_data: ac, cPgmId: "AcStatus", cAction: "DelRec"})
            showSuccess("Input Date & Time " + ac.d_inpputDate +" "+ ac.d_inpputTime + " record deleted")
            for (let i = 0; i < data.length; i++) {
                if (data[i].d_acCode === res.data.data.d_acCode) {
                    data[i] = { ...data[i], ...res.data.data }
                    setData(data)
                    break
                }
            }
            setcurrentAcStatus(res.data.data)
            setCurrentMode("show")
        } catch (error) {
            utils.showError(error)
        }
*/        
    }

    const NextRecProcess = async (AcStatus: AcStatusInfo) => {
/*        
        try {
            //console.log("call NextRecProcess", ac)
            const res = await gsb.post('/Master', {sb_data: ac, cPgmId: "AcStatus", cAction: "NextRec"})
            for (let i = 0; i < data.length; i++) {
                if (data[i].d_acCode === res.data.data.d_acCode) {
                    data[i] = { ...data[i], ...res.data.data }
                    setData(data)
                    break
                }
            }
            setcurrentAcStatus(res.data.data)
            setCurrentMode("show")
        } catch (error) {
            utils.showError(error)
        }
*/        
    }


    const newOnSave = async (AcStatus: AcStatusInfo) => {
/*        
        try {
            const res = await gsb.post('/Master', {sb_data: ac, cPgmId: "AcStatus", cAction: "AddRec"})
            showSuccess("Input Date & Time " + ac.d_inpputDate +" "+ ac.d_inpputTime + " record added")

            for (let i = 0; i < data.length; i++) {
                if (data[i].d_acCode === res.data.data.d_acCode) {
                    data[i] = { ...data[i], ...res.data.data }
                    setData(data)
                    break
                }
            }
            setcurrentAcStatus(res.data.data)
            setCurrentMode("show")
        } catch (error) {
            utils.showError(error)
        }
*/        
    }

    const editOnSave = async (AcStatus: AcStatusInfo) => {

        try {
            
            const res = await gsb.post('/Master', {sb_data: AcStatus, cPgmId: "AcStatus", cAction: "UpdateRec"})
            if ( res.data.ok ) {
                setcurrentAcStatus(res.data.data[0])
                showSuccess("Account Status Code Record Saved")
                //setisShowAlert1(true)
                //setShowAlert1Msg(res.data.data_Msg)
                setCurrentMode("show")
            } else {
                setisShowAlert2(true)
                setShowAlert2Msg(res.data.err_Msg)
                setCurrentMode("show")
            }

        } catch (error) {
            utils.showError(error)
        }
    }



    const showErrorBox = (err: any) => {
        alert("Error:"+err.response.data.subSystem+" - "+err.response.data.description+", OS code:"+err.response.data.osCode)
    }

    const showError = (err: any) => {
        if (err.response) {
            toaster.show({ message: err.response.data.description, intent: Intent.WARNING })
        } else if (err.request) {
            toaster.show({ message: "Request failed", intent: Intent.WARNING })
        } else {
            toaster.show({ message: err.message, intent: Intent.WARNING })
        }
    }

    const showSuccess = (message: string) => {
        toaster.show({ message: message, intent: Intent.SUCCESS })
    }

    // currentMode = show
    let detail = <AcStatusView gsb={gsb} AcStatus={currentAcStatus} baseUrl={gsb.defaults.baseURL} token={localStorage.getItem('token')} onPrevRec={() => PrevRecProcess(currentAcStatus)} onNew={() => setCurrentMode("new")} onEdit={() => setCurrentMode("edit")} onDelete={() => DeleteProcess(currentAcStatus)} onNextRec={() => NextRecProcess(currentAcStatus)} ></AcStatusView>
    switch (currentMode) {
        case "edit":
            detail = <AcStatusEdit gsb={gsb} AcStatus={currentAcStatus} onSave={editOnSave} onCancel={() => { setCurrentMode("show") } }></AcStatusEdit>
            break
        case "new":
            detail = <AcStatusEdit gsb={gsb} AcStatus={currentAcStatus} isNew onSave={newOnSave} onCancel={() => { setCurrentMode("show"); setSelectedTabId("detail") } }></AcStatusEdit>
            break
    }

    function PageNo(n: number) {
        if (n > 0 ) {
            if ( nPage+n <= nTotalPage ) {
                setnPage(nPage+n)
            }
        } else
        {
            if ( nPage+n > 0 ) {
                setnPage(nPage+n)
            }
        }
        return null;
    }

    let Pagination = <>
        <div className="Row">
            <FormGroup className="Col-1-12" label="">
                Page
                { (nTotalPage > 1) &&
                    <Button minimal onClick={() =>PageNo(-1)}>&laquo;</Button>
                }
                { (nTotalPage > 1) && (nPage != 1) && 
                    <Button minimal onClick={() => setnPage(1)}>{1}</Button>
                }
                {aPageNumber.map((no, j) => 
                    (j+1 > nPage-10) && (j+1 < nPage) && (j+1 != 1) && <Button minimal onClick={() => setnPage(no.n)}>{no.n}</Button>
                )}
                { (nTotalPage >= 1) && <Button intent='primary'>{nPage}</Button> }
                {aPageNumber.map((no, j) => 
                    (j+1 > nPage) && (j+1 < nPage+10) && (j+1 != nTotalPage) && <Button minimal onClick={() => setnPage(no.n)}>{no.n}</Button>
                )}
                { (nTotalPage > 1) && (nPage != nTotalPage) && 
                    <Button minimal onClick={() => setnPage(nTotalPage)}>{nTotalPage}</Button>
                }
                { (nTotalPage > 1) &&
                    <Button minimal onClick={() =>PageNo(+1)}>&raquo;</Button>
                }
            </FormGroup>
        </div>
    </>



    let list = <>
        <div className="Spacing-V-16" />
        {ShowWait && <div>{imgWait}</div> }
        {ShowWait && nTotalPage > 0 && <div>{imgWait}</div> }
        {nPage > 0 && Pagination}
    </>

    let CoHead = <SystemHeader companyLogo={companyLogoName} companyName={CO_NAME} dataPath={SBPath} tradeDate={TRAN_DATE} settlementDate={SETL_DATE}></SystemHeader>    

    return (
        <>
            <form >
                <div className="Spacing-V-Menu"></div>                
                <div className="Row">
                    <FormGroup className="Col-1-12"  >
                        {CoHead}
                    </FormGroup>
                </div>
                <Card className={cardOpen01} interactive={false} elevation={Elevation.THREE} >
                    <H3>Account Status Code Setup</H3>
                    {/*
                    <Tabs onChange={(newTabId) => setSelectedTabId(newTabId as string)} selectedTabId={selectedTabId}>
                        <Tab id="detail" title="Detail" panel={detail} />
                    </Tabs>
                    */}

                    {detail}
                    <p>Notes</p>
                    <div>
                        {/* <div>Codes {currentAcStatus.d_RESR_Code} are reserved, please do not change them.</div> */}
                        <div>Codes {RESR_Code} are reserved, please do not change them.</div>
                    </div >
                </Card>
                <div className="Spacing-V-16"></div>
                <Alert
                    confirmButtonText="OK"
                    icon="tick-circle"
                    intent={Intent.SUCCESS}
                    isOpen={isShowAlert1}
                    onCancel={ () => setisShowAlert1(false) }
                    onConfirm={ () => { setShowAlert1Msg(""); setisShowAlert1(false) } }
                >
                    <p>
                        {ShowAlert1Msg}
                    </p>
                </Alert>
                <Alert
                    confirmButtonText="OK"
                    icon="cross"
                    intent={Intent.WARNING}
                    isOpen={isShowAlert2}
                    onCancel={ () => setisShowAlert2(false) }
                    onConfirm={ () => { setShowAlert2Msg(""); setisShowAlert2(false) } }
                >
                    <p>
                        {ShowAlert2Msg}
                    </p>
                </Alert>
            </form>
        </>
    );
}

export default AcStatusMain